"use strict";
var Player = (() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/ts-nested-error@1.2.1/node_modules/ts-nested-error/build/nested-error.js
  var require_nested_error = __commonJS({
    "../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/ts-nested-error@1.2.1/node_modules/ts-nested-error/build/nested-error.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toError = exports.NestedError = void 0;
      var NestedError4 = class _NestedError extends Error {
        /**
         * Allocates an instance of `NestedError` with the given error `message` and
         * optional `innerError` (which will be automatically coerced using `toError()`).
         *
         * @param message     Laconic error message to attach to the created `NestedError`.
         * @param innerErrors Optional errors that will be wrapped by this higher level
         *                    error. This value will be automatically coerced using `toError()`.
         */
        constructor(message, ...innerErrors) {
          super(message);
          const thisErrorReport = _NestedError.getErrorReport(this);
          if (innerErrors.length === 1) {
            const innerError = toError(innerErrors[0]);
            this.innerErrors = [innerError];
            const errReport = _NestedError.getErrorReport(innerError);
            this.stack = `${thisErrorReport}

======= INNER ERROR =======

${errReport}`;
            return;
          }
          this.innerErrors = innerErrors.map((err) => toError(err));
          const innerErrorReports = this.innerErrors.map((error, idx) => {
            const errReport = _NestedError.getErrorReport(error);
            return `======= INNER ERROR (${idx + 1} of ${innerErrors.length}) =======

${errReport}`;
          }).join("\n\n");
          this.stack = `${thisErrorReport}

${innerErrorReports}`;
        }
        /**
         * Provides the first `Error` of the `innerErrors` (if it exists);
         * otherwise, `null`.
         *
         * @deprecated Please shift to using the `innerErrors` (with an 's') property.
         */
        get innerError() {
          return this.innerErrors.length === 0 ? null : this.innerErrors[0];
        }
        /**
         * Returns the function that accepts any value that was thrown as the first argument and
         * throws it wrapped into `NestedError` or class derived from `NestedError` (provided
         * this method was called directly in the context of that dervied class constructor)
         * with the given `message`.
         * Returned function will pass accepted `Error` object directly to `NestedError`
         * as `innerErrors` by invoking `toError(err)` on it.
         *
         * You'll most likely want to use this method with promises:
         *
         * ```ts
         * userService.getPage().then(
         *     data => console.log(`Hooray! data: ${data}`),
         *     NestedError.rethrow('failed to fetch users page')
         * );
         * ```
         *
         * @param message Message to attach `NestedError` created by the returned function.
         */
        static rethrow(message) {
          return (...errs) => {
            throw new this(message, ...errs);
          };
        }
      };
      exports.NestedError = NestedError4;
      NestedError4.getErrorReport = typeof new Error().stack === "string" ? (err) => err.stack : (err) => `${err.name}: ${err.message}`;
      NestedError4.prototype.name = "NestedError";
      function toError(err) {
        try {
          return err instanceof Error ? err : new Error(`Value that is not an instance of Error was thrown: ${err}`);
        } catch {
          return new Error("Failed to stringify non-instance of Error that was thrown.This is possibly due to the fact that toString() method of the valuedoesn't return a primitive value.");
        }
      }
      exports.toError = toError;
    }
  });

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/timm@1.7.1/node_modules/timm/lib/timm.js
  var require_timm = __commonJS({
    "../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/timm@1.7.1/node_modules/timm/lib/timm.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.clone = clone2;
      exports.addLast = addLast2;
      exports.addFirst = addFirst;
      exports.removeLast = removeLast;
      exports.removeFirst = removeFirst;
      exports.insert = insert;
      exports.removeAt = removeAt2;
      exports.replaceAt = replaceAt;
      exports.getIn = getIn;
      exports.set = set2;
      exports.setIn = setIn8;
      exports.update = update;
      exports.updateIn = updateIn;
      exports.merge = merge;
      exports.mergeDeep = mergeDeep;
      exports.mergeIn = mergeIn;
      exports.omit = omit3;
      exports.addDefaults = addDefaults;
      exports.default = void 0;
      var INVALID_ARGS = "INVALID_ARGS";
      var IS_DEV = false;
      function throwStr(msg) {
        throw new Error(msg);
      }
      function getKeysAndSymbols(obj) {
        const keys = Object.keys(obj);
        if (Object.getOwnPropertySymbols) {
          return keys.concat(Object.getOwnPropertySymbols(obj));
        }
        return keys;
      }
      var hasOwnProperty = {}.hasOwnProperty;
      function clone2(obj0) {
        if (Array.isArray(obj0))
          return obj0.slice();
        const obj = obj0;
        const keys = getKeysAndSymbols(obj);
        const out = {};
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          out[key] = obj[key];
        }
        return out;
      }
      function isObject(o) {
        return o != null && typeof o === "object";
      }
      function addLast2(array, val) {
        if (Array.isArray(val))
          return array.concat(val);
        return array.concat([val]);
      }
      function addFirst(array, val) {
        if (Array.isArray(val))
          return val.concat(array);
        return [val].concat(array);
      }
      function removeLast(array) {
        if (!array.length)
          return array;
        return array.slice(0, array.length - 1);
      }
      function removeFirst(array) {
        if (!array.length)
          return array;
        return array.slice(1);
      }
      function insert(array, idx, val) {
        return array.slice(0, idx).concat(Array.isArray(val) ? val : [val]).concat(array.slice(idx));
      }
      function removeAt2(array, idx) {
        if (idx >= array.length || idx < 0)
          return array;
        return array.slice(0, idx).concat(array.slice(idx + 1));
      }
      function replaceAt(array, idx, newItem) {
        if (array[idx] === newItem)
          return array;
        const len = array.length;
        const result = Array(len);
        for (let i = 0; i < len; i++) {
          result[i] = array[i];
        }
        result[idx] = newItem;
        return result;
      }
      function getIn(obj, path) {
        if (!Array.isArray(path)) {
          throwStr(IS_DEV ? "A path array should be provided when calling getIn()" : INVALID_ARGS);
        }
        if (obj == null)
          return void 0;
        let ptr = obj;
        for (let i = 0; i < path.length; i++) {
          const key = path[i];
          ptr = ptr != null ? ptr[key] : void 0;
          if (ptr === void 0)
            return ptr;
        }
        return ptr;
      }
      function set2(obj0, key, val) {
        let obj = obj0;
        if (obj == null)
          obj = typeof key === "number" ? [] : {};
        if (obj[key] === val)
          return obj;
        const obj2 = clone2(obj);
        obj2[key] = val;
        return obj2;
      }
      function setIn8(obj, path, val) {
        if (!path.length)
          return val;
        return doSetIn(obj, path, val, 0);
      }
      function doSetIn(obj, path, val, idx) {
        let newValue;
        const key = path[idx];
        if (idx === path.length - 1) {
          newValue = val;
        } else {
          const nestedObj = isObject(obj) && isObject(obj[key]) ? obj[key] : typeof path[idx + 1] === "number" ? [] : {};
          newValue = doSetIn(nestedObj, path, val, idx + 1);
        }
        return set2(obj, key, newValue);
      }
      function update(obj, key, fnUpdate) {
        const prevVal = obj == null ? void 0 : obj[key];
        const nextVal = fnUpdate(prevVal);
        return set2(obj, key, nextVal);
      }
      function updateIn(obj, path, fnUpdate) {
        const prevVal = getIn(obj, path);
        const nextVal = fnUpdate(prevVal);
        return setIn8(obj, path, nextVal);
      }
      function merge(a, b, c, d, e, f, ...rest) {
        return rest.length ? doMerge.call(null, false, false, a, b, c, d, e, f, ...rest) : doMerge(false, false, a, b, c, d, e, f);
      }
      function mergeDeep(a, b, c, d, e, f, ...rest) {
        return rest.length ? doMerge.call(null, false, true, a, b, c, d, e, f, ...rest) : doMerge(false, true, a, b, c, d, e, f);
      }
      function mergeIn(a, path, b, c, d, e, f, ...rest) {
        let prevVal = getIn(a, path);
        if (prevVal == null)
          prevVal = {};
        let nextVal;
        if (rest.length) {
          nextVal = doMerge.call(null, false, false, prevVal, b, c, d, e, f, ...rest);
        } else {
          nextVal = doMerge(false, false, prevVal, b, c, d, e, f);
        }
        return setIn8(a, path, nextVal);
      }
      function omit3(obj, attrs) {
        const omitList = Array.isArray(attrs) ? attrs : [attrs];
        let fDoSomething = false;
        for (let i = 0; i < omitList.length; i++) {
          if (hasOwnProperty.call(obj, omitList[i])) {
            fDoSomething = true;
            break;
          }
        }
        if (!fDoSomething)
          return obj;
        const out = {};
        const keys = getKeysAndSymbols(obj);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          if (omitList.indexOf(key) >= 0)
            continue;
          out[key] = obj[key];
        }
        return out;
      }
      function addDefaults(a, b, c, d, e, f, ...rest) {
        return rest.length ? doMerge.call(null, true, false, a, b, c, d, e, f, ...rest) : doMerge(true, false, a, b, c, d, e, f);
      }
      function doMerge(fAddDefaults, fDeep, first, ...rest) {
        let out = first;
        if (!(out != null)) {
          throwStr(IS_DEV ? "At least one object should be provided to merge()" : INVALID_ARGS);
        }
        let fChanged = false;
        for (let idx = 0; idx < rest.length; idx++) {
          const obj = rest[idx];
          if (obj == null)
            continue;
          const keys = getKeysAndSymbols(obj);
          if (!keys.length)
            continue;
          for (let j = 0; j <= keys.length; j++) {
            const key = keys[j];
            if (fAddDefaults && out[key] !== void 0)
              continue;
            let nextVal = obj[key];
            if (fDeep && isObject(out[key]) && isObject(nextVal)) {
              nextVal = doMerge(fAddDefaults, fDeep, out[key], nextVal);
            }
            if (nextVal === void 0 || nextVal === out[key])
              continue;
            if (!fChanged) {
              fChanged = true;
              out = clone2(out);
            }
            out[key] = nextVal;
          }
        }
        return out;
      }
      var timm = {
        clone: clone2,
        addLast: addLast2,
        addFirst,
        removeLast,
        removeFirst,
        insert,
        removeAt: removeAt2,
        replaceAt,
        getIn,
        set: set2,
        setIn: setIn8,
        update,
        updateIn,
        merge,
        mergeDeep,
        mergeIn,
        omit: omit3,
        addDefaults
      };
      var _default = timm;
      exports.default = _default;
    }
  });

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/p-defer@3.0.0/node_modules/p-defer/index.js
  var require_p_defer = __commonJS({
    "../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/p-defer@3.0.0/node_modules/p-defer/index.js"(exports, module) {
      "use strict";
      var pDefer = () => {
        const deferred2 = {};
        deferred2.promise = new Promise((resolve, reject) => {
          deferred2.resolve = resolve;
          deferred2.reject = reject;
        });
        return deferred2;
      };
      module.exports = pDefer;
    }
  });

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/queue-microtask@1.2.3/node_modules/queue-microtask/index.js
  var require_queue_microtask = __commonJS({
    "../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/queue-microtask@1.2.3/node_modules/queue-microtask/index.js"(exports, module) {
      "use strict";
      var promise;
      module.exports = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : global) : (cb) => (promise || (promise = Promise.resolve())).then(cb).catch((err) => setTimeout(() => {
        throw err;
      }, 0));
    }
  });

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/sorted-array@2.0.4/node_modules/sorted-array/sorted-array.js
  var require_sorted_array = __commonJS({
    "../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/sorted-array@2.0.4/node_modules/sorted-array/sorted-array.js"(exports, module) {
      "use strict";
      var SortedArray2 = function() {
        var SortedArray3 = defclass({
          constructor: function(array, compare) {
            this.array = [];
            this.compare = compare || compareDefault;
            var length = array.length, index = 0;
            while (index < length)
              this.insert(array[index++]);
          },
          insert: function(element) {
            var array = this.array, compare = this.compare, high = array.length - 1, low = 0, pos = -1, index, ordering;
            while (high >= low) {
              index = (high + low) / 2 >>> 0;
              ordering = compare(array[index], element);
              if (ordering < 0)
                low = index + 1;
              else if (ordering > 0)
                high = index - 1;
              else {
                pos = index;
                break;
              }
              ;
            }
            if (pos === -1) {
              pos = high;
            }
            pos++;
            high = array.length - 1;
            while (pos < high && compare(element, array[pos]) === 0) {
              pos++;
            }
            index = array.length;
            array.push(element);
            while (index > pos) {
              array[index] = array[--index];
            }
            array[pos] = element;
            return this;
          },
          search: function(element) {
            var array = this.array, compare = this.compare, high = array.length - 1, low = 0, index, ordering;
            while (high >= low) {
              index = (high + low) / 2 >>> 0;
              ordering = compare(array[index], element);
              if (ordering < 0)
                low = index + 1;
              else if (ordering > 0)
                high = index - 1;
              else
                return index;
            }
            return -1;
          },
          remove: function(element) {
            var index = this.search(element);
            if (index >= 0)
              this.array.splice(index, 1);
            return this;
          }
        });
        SortedArray3.comparing = function(property, array) {
          return new SortedArray3(array, function(a, b) {
            return compareDefault(a[property], b[property]);
          });
        };
        return SortedArray3;
        function defclass(prototype) {
          var constructor = prototype.constructor;
          constructor.prototype = prototype;
          return constructor;
        }
        function compareDefault(a, b) {
          if (a < b)
            return -1;
          else if (a > b)
            return 1;
          else
            return 0;
        }
      }();
      if (typeof module === "object")
        module.exports = SortedArray2;
      if (typeof define === "function" && define.amd)
        define(function() {
          return SortedArray2;
        });
    }
  });

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/index.ts
  var src_exports = {};
  __export(src_exports, {
    ApplicabilityPlugin: () => ApplicabilityPlugin,
    AssetPlugin: () => AssetPlugin,
    AssetTransformCorePlugin: () => AssetTransformCorePlugin,
    BINDING_BRACKETS_REGEX: () => BINDING_BRACKETS_REGEX,
    BindingInstance: () => BindingInstance,
    BindingParser: () => BindingParser,
    Builder: () => Builder,
    ConsoleLogger: () => ConsoleLogger,
    ConstantsController: () => ConstantsController,
    DataController: () => DataController,
    DependencyMiddleware: () => DependencyMiddleware,
    DependencyModel: () => DependencyModel,
    DependencyTracker: () => DependencyTracker,
    EMPTY_NODE: () => EMPTY_NODE,
    ExpNodeOpaqueIdentifier: () => ExpNodeOpaqueIdentifier,
    ExpressionEvaluator: () => ExpressionEvaluator,
    FlowController: () => FlowController,
    FlowExpPlugin: () => FlowExpPlugin,
    FlowInstance: () => FlowInstance,
    LocalModel: () => LocalModel,
    LocalStateStore: () => LocalStateStore,
    MultiNodePlugin: () => MultiNodePlugin,
    NOOPDataModel: () => NOOPDataModel,
    NOOP_MODEL: () => NOOP_MODEL,
    NOT_STARTED_STATE: () => NOT_STARTED_STATE,
    NodeType: () => NodeType,
    NoopLogger: () => NoopLogger,
    Parser: () => Parser,
    PipelinedDataModel: () => PipelinedDataModel,
    Player: () => Player,
    ProxyLogger: () => ProxyLogger,
    ROOT_BINDING: () => ROOT_BINDING,
    Resolver: () => Resolver,
    SCHEMA_VALIDATION_PROVIDER_NAME: () => SCHEMA_VALIDATION_PROVIDER_NAME,
    SIMPLE_BINDING_REGEX: () => SIMPLE_BINDING_REGEX,
    SchemaController: () => SchemaController,
    StringResolverPlugin: () => StringResolverPlugin,
    SwitchPlugin: () => SwitchPlugin,
    TapableLogger: () => TapableLogger,
    TemplatePlugin: () => TemplatePlugin,
    VALIDATION_PROVIDER_NAME_SYMBOL: () => VALIDATION_PROVIDER_NAME_SYMBOL,
    VIEW_VALIDATION_PROVIDER_NAME: () => VIEW_VALIDATION_PROVIDER_NAME,
    ValidationBindingTrackerViewPlugin: () => ValidationBindingTrackerViewPlugin,
    ValidationController: () => ValidationController,
    ValidationMiddleware: () => ValidationMiddleware,
    ValidatorRegistry: () => ValidatorRegistry,
    ViewController: () => ViewController,
    ViewInstance: () => ViewInstance,
    caresAboutDataChanges: () => caresAboutDataChanges,
    constructModelForPipeline: () => constructModelForPipeline,
    findClosestNodeAtPosition: () => findClosestNodeAtPosition,
    findInArray: () => findInArray,
    findNextExp: () => findNextExp,
    getBindingSegments: () => getBindingSegments,
    getNodeID: () => getNodeID,
    hasSwitchKey: () => hasSwitchKey,
    hasTemplateKey: () => hasTemplateKey,
    hasTemplateValues: () => hasTemplateValues,
    isAwaitable: () => isAwaitable,
    isBinding: () => isBinding,
    isErrorWithLocation: () => isErrorWithLocation,
    isExpressionNode: () => isExpressionNode,
    isObjectExpression: () => isObjectExpression,
    isPromiseLike: () => isPromiseLike,
    maybeConvertToNum: () => maybeConvertToNum,
    parse: () => parse2,
    parseExpression: () => parseExpression,
    removeBindingAndChildrenFromMap: () => removeBindingAndChildrenFromMap,
    resolveDataRefs: () => resolveDataRefs,
    resolveDataRefsInString: () => resolveDataRefsInString,
    resolveExpressionsInString: () => resolveExpressionsInString,
    severities: () => severities,
    toModel: () => toModel,
    toNodeResolveOptions: () => toNodeResolveOptions,
    withParser: () => withParser,
    withoutContext: () => withoutContext
  });

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/tapable-ts@0.2.4/node_modules/tapable-ts/dist/hooks.mjs
  function equalToOrIn(value, check) {
    if (Array.isArray(check)) {
      return check.includes(value);
    }
    return check === value;
  }
  function callTap(tap, args, ctx) {
    if (tap.context) {
      return tap.callback(ctx, ...args);
    }
    return tap.callback(...args);
  }
  var InterceptionManager = class {
    constructor() {
      this.interceptions = [];
      this.interceptionKeySet = /* @__PURE__ */ new Set();
    }
    isUsed() {
      return this.interceptions.length > 0;
    }
    intercept(int) {
      this.interceptions.push(int);
      Object.keys(int).forEach((s) => {
        this.interceptionKeySet.add(s);
      });
    }
    tap(tap) {
      if (this.interceptionKeySet.has("tap")) {
        this.interceptions.forEach((i) => {
          var _a;
          (_a = i.tap) == null ? void 0 : _a.call(i, tap);
        });
      }
    }
    call(ctx, ...args) {
      if (this.interceptionKeySet.has("call")) {
        this.interceptions.forEach((i) => {
          var _a, _b;
          if (i.context) {
            (_a = i.call) == null ? void 0 : _a.call(i, ctx, ...args);
          } else {
            (_b = i.call) == null ? void 0 : _b.call(i, ...args);
          }
        });
      }
    }
    loop(...args) {
      if (this.interceptionKeySet.has("loop")) {
        this.interceptions.forEach((i) => {
          var _a;
          (_a = i.loop) == null ? void 0 : _a.call(i, ...args);
        });
      }
    }
    error(err) {
      if (this.interceptionKeySet.has("error")) {
        if (err instanceof Error) {
          const asError = err;
          this.interceptions.forEach((i) => {
            var _a;
            (_a = i.error) == null ? void 0 : _a.call(i, asError);
          });
        }
      }
    }
    result(r) {
      if (this.interceptionKeySet.has("result")) {
        this.interceptions.forEach((i) => {
          var _a;
          (_a = i.result) == null ? void 0 : _a.call(i, r);
        });
      }
    }
    done() {
      if (this.interceptionKeySet.has("done")) {
        this.interceptions.forEach((i) => {
          var _a;
          (_a = i.done) == null ? void 0 : _a.call(i);
        });
      }
    }
  };
  var Hook = class {
    constructor() {
      this.taps = [];
      this.interceptions = new InterceptionManager();
    }
    tap(options, callback) {
      const resolvedOptions = typeof options === "string" ? {
        name: options,
        context: false
      } : {
        context: false,
        ...options
      };
      const key = Symbol(resolvedOptions.name);
      const tap = {
        key,
        ...resolvedOptions,
        callback
      };
      if (tap.before) {
        let insertionIndex = this.taps.length;
        const beforeSet = new Set(Array.isArray(tap.before) ? tap.before : [tap.before]);
        for (insertionIndex; insertionIndex > 0 && beforeSet.size > 0; insertionIndex--) {
          const t2 = this.taps[insertionIndex - 1];
          if (beforeSet.has(t2.name)) {
            beforeSet.delete(t2.name);
          }
          if (t2.before && equalToOrIn(tap.name, t2.before)) {
            break;
          }
        }
        this.taps.splice(insertionIndex, 0, tap);
      } else {
        this.taps.push(tap);
      }
      this.interceptions.tap(tap);
      return tap;
    }
    untap(tap) {
      this.taps = this.taps.filter((t2) => t2.key !== tap.key);
    }
    isUsed() {
      return this.taps.length > 0 || this.interceptions.isUsed();
    }
    intercept(int) {
      this.interceptions.intercept(int);
    }
  };
  var SyncHook = class extends Hook {
    call(...args) {
      if (!this.isUsed()) {
        return;
      }
      const ctx = {};
      this.interceptions.call(ctx, ...args);
      try {
        this.taps.forEach((t2) => {
          callTap(t2, args, ctx);
        });
      } catch (err) {
        this.interceptions.error(err);
        throw err;
      }
      this.interceptions.done();
    }
  };
  var SyncBailHook = class extends Hook {
    call(...args) {
      if (!this.isUsed()) {
        return;
      }
      const ctx = {};
      this.interceptions.call(ctx, ...args);
      for (let tapIndex = 0; tapIndex < this.taps.length; tapIndex += 1) {
        const rtn = callTap(this.taps[tapIndex], args, ctx);
        if (rtn !== void 0) {
          this.interceptions.result(rtn);
          return rtn;
        }
      }
      this.interceptions.done();
    }
  };
  var SyncWaterfallHook = class extends Hook {
    call(...args) {
      const ctx = {};
      this.interceptions.call(ctx, ...args);
      let [rtn, ...rest] = args;
      for (let tapIndex = 0; tapIndex < this.taps.length; tapIndex += 1) {
        const tapValue = callTap(this.taps[tapIndex], [rtn, ...rest], ctx);
        if (tapValue !== void 0) {
          rtn = tapValue;
        }
      }
      this.interceptions.result(rtn);
      return rtn;
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/binding/index.ts
  var import_ts_nested_error2 = __toESM(require_nested_error());

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/binding-grammar/ast.ts
  var toValue = (value) => ({
    name: "Value",
    value
  });
  var toExpression = (value) => ({
    name: "Expression",
    value
  });
  var toPath = (path) => ({
    name: "PathNode",
    path
  });
  var toQuery = (key, value) => ({
    name: "Query",
    key,
    value
  });
  var toConcatenatedNode = (values) => {
    if (values.length === 1) {
      return values[0];
    }
    return {
      name: "Concatenated",
      value: values
    };
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/binding-grammar/custom/index.ts
  var SEGMENT_SEPARATOR = ".";
  var OPEN_CURL = "{";
  var CLOSE_CURL = "}";
  var OPEN_BRACKET = "[";
  var CLOSE_BRACKET = "]";
  var EQUALS = "=";
  var SINGLE_QUOTE = "'";
  var DOUBLE_QUOTE = '"';
  var BACK_TICK = "`";
  var isIdentifierChar = (char) => {
    if (!char) {
      return false;
    }
    const charCode = char.charCodeAt(0);
    const matches = charCode === 32 || // ' '
    charCode === 34 || // "
    charCode === 39 || // '
    charCode === 40 || // (
    charCode === 41 || // )
    charCode === 42 || // *
    charCode === 46 || // .
    charCode === 61 || // =
    charCode === 91 || // [
    charCode === 93 || // ]
    charCode === 96 || // `
    charCode === 123 || // {
    charCode === 125;
    return !matches;
  };
  var parse = (path) => {
    let index = 1;
    let ch = path.charAt(0);
    const next = (expected) => {
      if (expected && ch !== expected) {
        throw new Error(`Expected char: ${expected} but got: ${ch}`);
      }
      ch = path.charAt(index);
      index += 1;
      return ch;
    };
    const whitespace = () => {
      while (ch === " ") {
        next();
      }
    };
    const identifier = (allowBoolValue = false) => {
      if (!isIdentifierChar(ch)) {
        return;
      }
      let value = ch;
      while (next()) {
        if (!isIdentifierChar(ch)) {
          break;
        }
        value += ch;
      }
      if (allowBoolValue) {
        if (value === "true") {
          return toValue(true);
        }
        if (value === "false") {
          return toValue(false);
        }
      }
      if (value) {
        const maybeNumber = Number(value);
        value = isNaN(maybeNumber) ? value : maybeNumber;
        return toValue(value);
      }
    };
    const expression = () => {
      if (ch === BACK_TICK) {
        next(BACK_TICK);
        let exp = ch;
        while (next()) {
          if (ch === BACK_TICK) {
            break;
          }
          exp += ch;
        }
        next(BACK_TICK);
        if (exp) {
          return toExpression(exp);
        }
      }
    };
    const regex = (match) => {
      if (!ch?.match(match)) {
        return;
      }
      let value = ch;
      while (next()) {
        if (!ch?.match(match)) {
          break;
        }
        value += ch;
      }
      if (value) {
        return toValue(value);
      }
    };
    const nestedPath = () => {
      if (ch === OPEN_CURL) {
        next(OPEN_CURL);
        next(OPEN_CURL);
        const modelRef = parsePath();
        next(CLOSE_CURL);
        next(CLOSE_CURL);
        return modelRef;
      }
    };
    const simpleSegment = (allowBoolValue = false) => nestedPath() ?? expression() ?? identifier(allowBoolValue);
    const segment = () => {
      const segments = [];
      let nextSegment = simpleSegment();
      while (nextSegment !== void 0) {
        segments.push(nextSegment);
        nextSegment = simpleSegment();
      }
      if (segments.length === 0) {
        return void 0;
      }
      return toConcatenatedNode(segments);
    };
    const optionallyQuotedSegment = (allowBoolValue = false) => {
      whitespace();
      if (ch === SINGLE_QUOTE || ch === DOUBLE_QUOTE) {
        const singleQuote = ch === SINGLE_QUOTE;
        next(singleQuote ? SINGLE_QUOTE : DOUBLE_QUOTE);
        const id = regex(/[^'"]+/);
        next(singleQuote ? SINGLE_QUOTE : DOUBLE_QUOTE);
        return id;
      }
      return simpleSegment(allowBoolValue);
    };
    const equals = () => {
      if (ch !== EQUALS) {
        return false;
      }
      while (ch === EQUALS) {
        next();
      }
      return true;
    };
    const parseBracket = () => {
      if (ch === OPEN_BRACKET) {
        next(OPEN_BRACKET);
        whitespace();
        let value = optionallyQuotedSegment();
        if (value) {
          whitespace();
          if (equals()) {
            whitespace();
            const second = optionallyQuotedSegment(true);
            value = toQuery(value, second);
            whitespace();
          }
        } else {
          throw new Error(`Expected identifier`);
        }
        if (value) {
          next(CLOSE_BRACKET);
        }
        return value;
      }
    };
    const parseSegmentAndBrackets = () => {
      const parsed = [];
      const firstSegment = segment();
      if (firstSegment) {
        parsed.push(firstSegment);
        let bracketSegment = parseBracket();
        if (bracketSegment?.name === "Value") {
          const maybeNumber = Number(bracketSegment.value);
          bracketSegment.value = isNaN(maybeNumber) || String(maybeNumber) !== bracketSegment.value ? bracketSegment.value : maybeNumber;
        }
        while (bracketSegment !== void 0) {
          parsed.push(bracketSegment);
          bracketSegment = parseBracket();
        }
      }
      return parsed;
    };
    const parsePath = () => {
      const parts = [];
      let nextSegment = parseSegmentAndBrackets();
      while (nextSegment !== void 0) {
        parts.push(...nextSegment);
        if (!ch || ch === CLOSE_CURL) {
          break;
        }
        if (nextSegment.length === 0 && ch) {
          throw new Error(`Unexpected character: ${ch}`);
        }
        next(SEGMENT_SEPARATOR);
        nextSegment = parseSegmentAndBrackets();
      }
      return toPath(parts);
    };
    try {
      const result = parsePath();
      return {
        status: true,
        path: result
      };
    } catch (e) {
      return {
        status: false,
        error: e.message
      };
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/binding/utils.ts
  function isBinding(binding) {
    return !(typeof binding === "string" || Array.isArray(binding));
  }
  function maybeConvertToNum(i) {
    const asInt = parseInt(i, 10);
    if (isNaN(asInt)) {
      return i;
    }
    return asInt;
  }
  function getBindingSegments(binding) {
    if (Array.isArray(binding)) {
      return binding;
    }
    if (typeof binding === "string") {
      return binding.split(".");
    }
    return binding.asArray();
  }
  function findInArray(array, key, value) {
    return array.findIndex((obj) => {
      if (obj && typeof obj === "object") {
        return obj[key] == value;
      }
      return false;
    });
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/binding/binding.ts
  var BindingInstance = class _BindingInstance {
    constructor(raw, factory = (rawBinding) => new _BindingInstance(rawBinding)) {
      const split = Array.isArray(raw) ? raw : raw.split(".");
      this.split = split.map((segment) => {
        if (typeof segment === "number") {
          return segment;
        }
        const tryNum = Number(segment);
        return isNaN(tryNum) || String(tryNum) !== segment ? segment : tryNum;
      });
      Object.freeze(this.split);
      this.joined = this.split.join(".");
      this.factory = factory;
    }
    asArray() {
      return this.split;
    }
    asString() {
      return this.joined;
    }
    /**
     * Check to see if the given binding is a sub-path of the current one
     */
    contains(binding) {
      const bindingAsArray = binding.asArray();
      if (bindingAsArray.length < this.split.length) {
        return false;
      }
      for (let i = 0; i < this.split.length; i++) {
        if (this.split[i] !== bindingAsArray[i]) {
          return false;
        }
      }
      return true;
    }
    relative(binding) {
      return this.asArray().slice(binding.asArray().length);
    }
    parent() {
      return this.factory(this.split.slice(0, -1));
    }
    key() {
      return this.split[this.split.length - 1];
    }
    /**
     * This is a utility method to get a binding that is a descendent of this binding
     *
     * @param relative - The relative path to descend to
     */
    descendent(relative) {
      const descendentSegments = getBindingSegments(relative);
      return this.factory(this.split.concat(descendentSegments));
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/binding/resolver.ts
  var import_ts_nested_error = __toESM(require_nested_error());
  function resolveBindingAST(bindingPathNode, options, hooks) {
    const context = {
      updates: {},
      path: []
    };
    function getValueForNode(node) {
      if (node.name === "Value") {
        return node.value;
      }
      if (node.name === "PathNode") {
        const nestedResolvedValue = resolveBindingAST(node, options);
        if (nestedResolvedValue.updates) {
          context.updates = {
            ...context.updates,
            ...nestedResolvedValue.updates
          };
        }
        try {
          return options.convertToPath(
            options.getValue(nestedResolvedValue.path)
          );
        } catch (e) {
          throw new import_ts_nested_error.NestedError(
            `Unable to resolve path segment: ${nestedResolvedValue.path}`,
            e
          );
        }
      }
      if (node.name === "Expression") {
        try {
          const actualValue = options.evaluate(node.value);
          return options.convertToPath(actualValue);
        } catch (e) {
          throw new import_ts_nested_error.NestedError(`Unable to resolve path: ${node.value}`, e);
        }
      }
      throw new Error(`Unable to resolve value for node: ${node.name}`);
    }
    function appendPathSegments(segment) {
      if (typeof segment === "string" && segment.indexOf(".") > -1) {
        segment.split(".").forEach((i) => {
          context.path.push(maybeConvertToNum(i));
        });
      } else {
        context.path.push(segment);
      }
    }
    function resolveNode(_node) {
      const resolvedNode = hooks?.beforeResolveNode.call(_node, { ...context, ...options }) ?? _node;
      switch (resolvedNode.name) {
        case "Expression":
        case "PathNode":
          appendPathSegments(getValueForNode(resolvedNode));
          break;
        case "Value":
          appendPathSegments(
            typeof resolvedNode.value === "boolean" ? String(resolvedNode.value) : resolvedNode.value
          );
          break;
        case "Query": {
          const objToQuery = options.getValue(context.path) ?? [];
          const { key, value } = resolvedNode;
          const resolvedKey = getValueForNode(key);
          const resolvedValue = value && getValueForNode(value);
          const index = findInArray(objToQuery, resolvedKey, resolvedValue);
          if (index === void 0 || index === -1) {
            context.updates[[...context.path, objToQuery.length, resolvedKey].join(".")] = resolvedValue;
            context.path.push(objToQuery.length);
          } else {
            context.path.push(index);
          }
          break;
        }
        case "Concatenated":
          context.path.push(resolvedNode.value.map(getValueForNode).join(""));
          break;
        default:
          throw new Error(`Unsupported node type: ${resolvedNode.name}`);
      }
    }
    bindingPathNode.path.forEach(resolveNode);
    return {
      path: context.path,
      updates: Object.keys(context.updates ?? {}).length > 0 ? context.updates : void 0
    };
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/binding/index.ts
  var SIMPLE_BINDING_REGEX = /^[\w\-@]+(\.[\w\-@]+)*$/;
  var BINDING_BRACKETS_REGEX = /[\s()*=`{}'"[\]]/;
  var LAZY_BINDING_REGEX = /^[^.]+(\..+)*$/;
  var DEFAULT_OPTIONS = {
    get: () => {
      throw new Error("Not Implemented");
    },
    set: () => {
      throw new Error("Not Implemented");
    },
    evaluate: () => {
      throw new Error("Not Implemented");
    }
  };
  var BindingParser = class {
    constructor(options) {
      this.hooks = {
        skipOptimization: new SyncBailHook(),
        beforeResolveNode: new SyncWaterfallHook()
      };
      this.parserOptions = { ...DEFAULT_OPTIONS, ...options };
      this.cache = {};
      this.parseCache = {};
      this.parse = this.parse.bind(this);
    }
    /**
     * Takes a binding path, parses it, and returns an equivalent, normalized
     * representation of that path.
     */
    normalizePath(path, resolveOptions) {
      if (!BINDING_BRACKETS_REGEX.test(path) && LAZY_BINDING_REGEX.test(path) && this.hooks.skipOptimization.call(path) !== true) {
        return { path: path.split("."), updates: void 0 };
      }
      const ast = this.parseCache[path] ?? parse(path);
      this.parseCache[path] = ast;
      if (typeof ast !== "object" || !ast?.status) {
        throw new TypeError(
          `Cannot normalize path "${path}": ${ast?.error ?? "Unknown Error."}`
        );
      }
      try {
        return resolveBindingAST(ast.path, resolveOptions, this.hooks);
      } catch (e) {
        throw new import_ts_nested_error2.NestedError(`Cannot resolve binding: ${path}`, e);
      }
    }
    getBindingForNormalizedResult(normalized) {
      const normalizedStr = normalized.path.join(".");
      if (this.cache[normalizedStr]) {
        return this.cache[normalizedStr];
      }
      const created = new BindingInstance(
        normalizedStr === "" ? [] : normalized.path,
        this.parse
      );
      this.cache[normalizedStr] = created;
      return created;
    }
    parse(rawBinding, overrides = {}) {
      if (isBinding(rawBinding)) {
        return rawBinding;
      }
      const options = {
        ...this.parserOptions,
        ...overrides
      };
      let updates = {};
      const joined = Array.isArray(rawBinding) ? rawBinding.join(".") : String(rawBinding);
      const normalizeConfig = {
        getValue: (path) => {
          const normalized2 = this.normalizePath(path.join("."), normalizeConfig);
          return options.get(this.getBindingForNormalizedResult(normalized2));
        },
        evaluate: (exp) => {
          return options.evaluate(exp);
        },
        convertToPath: (path) => {
          if (path === void 0) {
            throw new Error(
              "Attempted to convert undefined value to binding path"
            );
          }
          if (typeof path !== "string" && typeof path !== "number" && typeof path !== "boolean") {
            throw new Error(
              `Attempting to convert ${typeof path} to a binding path.`
            );
          }
          const normalized2 = this.normalizePath(String(path), normalizeConfig);
          if (normalized2.updates) {
            updates = {
              ...updates,
              ...normalized2.updates
            };
          }
          const joinedNormalizedPath = normalized2.path.join(".");
          if (joinedNormalizedPath === "") {
            throw new Error("Nested path resolved to an empty path");
          }
          return joinedNormalizedPath;
        }
      };
      const normalized = this.normalizePath(joined, normalizeConfig);
      if (normalized.updates) {
        updates = {
          ...updates,
          ...normalized.updates
        };
      }
      const updateKeys = Object.keys(updates);
      if (!options.readOnly && updateKeys.length > 0) {
        const updateTransaction = updateKeys.map(
          (updatedBinding) => [
            this.parse(updatedBinding),
            updates[updatedBinding]
          ]
        );
        options.set(updateTransaction);
      }
      return this.getBindingForNormalizedResult(normalized);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/data/dependency-tracker.ts
  var DependencyTracker = class {
    constructor() {
      this.readDeps = /* @__PURE__ */ new Set();
      this.writeDeps = /* @__PURE__ */ new Set();
      this.namedDependencySets = {};
      this.namedSet = "core";
      this.createSubset("core");
      this.createSubset("children");
    }
    createSubset(name, force = false) {
      if (force || !this.namedDependencySets[name]) {
        this.namedDependencySets[name] = {
          readDeps: /* @__PURE__ */ new Set(),
          writeDeps: /* @__PURE__ */ new Set()
        };
      }
    }
    /** Grab all of the bindings that this depended on */
    getDependencies(name) {
      if (name !== void 0) {
        return this.namedDependencySets?.[name]?.readDeps ?? /* @__PURE__ */ new Set();
      }
      return this.readDeps;
    }
    trackSubset(name) {
      this.createSubset(name);
      this.namedSet = name;
    }
    trackDefault() {
      this.namedSet = "core";
    }
    /** Grab all of the bindings this wrote to */
    getModified(name) {
      if (name !== void 0) {
        return this.namedDependencySets?.[name]?.writeDeps ?? /* @__PURE__ */ new Set();
      }
      return this.writeDeps;
    }
    /**
     * Check to see if the dataModel has read the value at the given binding
     *
     * @param binding - The binding you want to check for
     */
    readsBinding(binding) {
      return this.readDeps.has(binding);
    }
    /**
     * Check to see if the dataModel has written to the binding
     */
    writesBinding(binding) {
      return this.writeDeps.has(binding);
    }
    /** Reset all tracking of dependencies */
    reset() {
      this.readDeps = /* @__PURE__ */ new Set();
      this.writeDeps = /* @__PURE__ */ new Set();
      this.namedDependencySets = {};
      this.namedSet = "core";
      this.createSubset("core", true);
      this.createSubset("children", true);
    }
    addReadDep(binding, namedSet = this.namedSet) {
      if (namedSet) {
        this.namedDependencySets?.[namedSet]?.readDeps.add(binding);
      }
      this.readDeps.add(binding);
    }
    addWriteDep(binding, namedSet = this.namedSet) {
      if (namedSet) {
        this.namedDependencySets?.[namedSet]?.writeDeps.add(binding);
      }
      this.writeDeps.add(binding);
    }
    addChildReadDep(binding) {
      this.addReadDep(binding, "children");
    }
  };
  var DependencyMiddleware = class extends DependencyTracker {
    constructor() {
      super();
      this.get = this.get.bind(this);
      this.set = this.set.bind(this);
    }
    set(transaction, options, next) {
      transaction.forEach(([binding]) => this.addWriteDep(binding));
      return next?.set(transaction, options) ?? [];
    }
    get(binding, options, next) {
      this.addReadDep(binding);
      return next?.get(binding, options);
    }
    delete(binding, options, next) {
      this.addWriteDep(binding);
      return next?.delete(binding, options);
    }
  };
  var DependencyModel = class extends DependencyTracker {
    constructor(rootModel) {
      super();
      this.rootModel = rootModel;
      this.set = this.set.bind(this);
      this.get = this.get.bind(this);
    }
    set(transaction, options) {
      transaction.forEach(([binding]) => this.addWriteDep(binding));
      return this.rootModel.set(transaction, options);
    }
    get(binding, options) {
      this.addReadDep(binding);
      return this.rootModel.get(binding, options);
    }
    delete(binding, options) {
      this.addWriteDep(binding);
      return this.rootModel.delete(binding, options);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/data/noop-model.ts
  var NOOPDataModel = class {
    get() {
      return void 0;
    }
    set() {
      return [];
    }
    delete() {
    }
  };
  var NOOP_MODEL = new NOOPDataModel();

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/data/model.ts
  var ROOT_BINDING = new BindingInstance([]);
  function withParser(model, parseBinding) {
    function maybeParse(binding, readOnly) {
      const parsed = isBinding(binding) ? binding : parseBinding(binding, {
        get: model.get,
        set: model.set,
        readOnly
      });
      if (!parsed) {
        throw new Error("Unable to parse binding");
      }
      return parsed;
    }
    return {
      get(binding, options) {
        return model.get(maybeParse(binding, true), options);
      },
      set(transaction, options) {
        return model.set(
          transaction.map(([key, val]) => [maybeParse(key, false), val]),
          options
        );
      },
      delete(binding, options) {
        return model.delete(maybeParse(binding, false), options);
      }
    };
  }
  function toModel(middleware, defaultOptions, next) {
    if (!next) {
      return middleware;
    }
    return {
      get: (binding, options) => {
        const resolvedOptions = options ?? defaultOptions;
        if (middleware.get) {
          return middleware.get(binding, resolvedOptions, next);
        }
        return next?.get(binding, resolvedOptions);
      },
      set: (transaction, options) => {
        const resolvedOptions = options ?? defaultOptions;
        if (middleware.set) {
          return middleware.set(transaction, resolvedOptions, next);
        }
        return next?.set(transaction, resolvedOptions);
      },
      delete: (binding, options) => {
        const resolvedOptions = options ?? defaultOptions;
        if (middleware.delete) {
          return middleware.delete(binding, resolvedOptions, next);
        }
        return next?.delete(binding, resolvedOptions);
      }
    };
  }
  function constructModelForPipeline(pipeline) {
    if (pipeline.length === 0) {
      return NOOP_MODEL;
    }
    if (pipeline.length === 1) {
      return toModel(pipeline[0]);
    }
    function createModelWithOptions(options) {
      const model = pipeline.reduce(
        (nextModel, middleware) => toModel(middleware, options, nextModel),
        void 0
      ) ?? NOOP_MODEL;
      return model;
    }
    return {
      get: (binding, options) => {
        return createModelWithOptions(options)?.get(binding, options);
      },
      set: (transaction, options) => {
        return createModelWithOptions(options)?.set(transaction, options);
      },
      delete: (binding, options) => {
        return createModelWithOptions(options)?.delete(binding, options);
      }
    };
  }
  var PipelinedDataModel = class {
    constructor(pipeline = []) {
      this.hooks = {
        onSet: new SyncHook()
      };
      this.pipeline = pipeline;
      this.effectiveDataModel = constructModelForPipeline(this.pipeline);
    }
    setMiddleware(handlers) {
      this.pipeline = handlers;
      this.effectiveDataModel = constructModelForPipeline(handlers);
    }
    addMiddleware(handler) {
      this.pipeline = [...this.pipeline, handler];
      this.effectiveDataModel = constructModelForPipeline(this.pipeline);
    }
    reset(model = {}) {
      this.pipeline.forEach((middleware) => {
        if ("reset" in middleware) {
          middleware.reset?.();
        }
      });
      this.set([[ROOT_BINDING, model]]);
    }
    set(transaction, options) {
      const appliedTransaction = this.effectiveDataModel.set(
        transaction,
        options
      );
      this.hooks.onSet.call(transaction);
      return appliedTransaction;
    }
    get(binding, options) {
      return this.effectiveDataModel.get(binding, options);
    }
    delete(binding, options) {
      return this.effectiveDataModel.delete(binding, options);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/dlv@1.1.3/node_modules/dlv/dist/dlv.es.js
  function dlv_es_default(t2, e, l, n, r) {
    for (e = e.split ? e.split(".") : e, n = 0; n < e.length; n++)
      t2 = t2 ? t2[e[n]] : r;
    return t2 === r ? l : t2;
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/data/local-model.ts
  var import_timm = __toESM(require_timm());
  var LocalModel = class {
    constructor(model = {}) {
      this.model = model;
      this.get = this.get.bind(this);
      this.set = this.set.bind(this);
    }
    reset(model = {}) {
      this.model = model;
    }
    get(binding) {
      if (!binding || !binding.asString()) {
        return this.model;
      }
      return dlv_es_default(this.model, binding.asArray());
    }
    set(transaction) {
      const effectiveOperations = [];
      transaction.forEach(([binding, value]) => {
        const oldValue = this.get(binding);
        this.model = (0, import_timm.setIn)(this.model, binding.asArray(), value);
        effectiveOperations.push({ binding, oldValue, newValue: value });
      });
      return effectiveOperations;
    }
    delete(binding) {
      const parentBinding = binding.parent();
      if (parentBinding) {
        const parentValue = this.get(parentBinding);
        if (parentValue !== void 0) {
          if (Array.isArray(parentValue)) {
            this.model = (0, import_timm.setIn)(
              this.model,
              parentBinding.asArray(),
              (0, import_timm.removeAt)(parentValue, binding.key())
            );
          } else {
            this.model = (0, import_timm.setIn)(
              this.model,
              parentBinding.asArray(),
              (0, import_timm.omit)(parentValue, binding.key())
            );
          }
        }
      }
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/expressions/evaluator.ts
  var import_ts_nested_error3 = __toESM(require_nested_error());

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/expressions/types.ts
  var ExpNodeOpaqueIdentifier = Symbol("Expression Node ID");
  function isExpressionNode(x) {
    return typeof x === "object" && x !== null && !Array.isArray(x) && x.__id === ExpNodeOpaqueIdentifier;
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/expressions/parser.ts
  var PERIOD_CODE = 46;
  var COMMA_CODE = 44;
  var SQUOTE_CODE = 39;
  var DQUOTE_CODE = 34;
  var OPAREN_CODE = 40;
  var CPAREN_CODE = 41;
  var OBRACK_CODE = 91;
  var CBRACK_CODE = 93;
  var QUMARK_CODE = 63;
  var SEMCOL_CODE = 59;
  var COLON_CODE = 58;
  var OCURL_CODE = 123;
  var CCURL_CODE = 125;
  var t = true;
  var unaryOps = { "-": t, "!": t, "~": t, "+": t };
  var binaryOps = {
    "=": 3,
    "+=": 3,
    "-=": 3,
    "&=": 3,
    "|=": 3,
    // Conditional: 4,
    "||": 5,
    "&&": 6,
    "|": 7,
    "^": 8,
    "&": 9,
    "==": 10,
    "!=": 10,
    "===": 10,
    "!==": 10,
    "<": 11,
    ">": 11,
    "<=": 11,
    ">=": 11,
    "<<": 12,
    ">>": 12,
    ">>>": 12,
    "+": 13,
    "-": 13,
    "*": 14,
    "/": 14,
    "%": 14
  };
  function throwError(message, index) {
    const err = new Error(`${message} at character ${index}`);
    err.index = index;
    err.description = message;
    throw err;
  }
  function createSpanningLocation(start, end) {
    if (!start || !end) {
      return;
    }
    return {
      start: start.start,
      end: end.end
    };
  }
  function getMaxKeyLen(obj) {
    let maxLen = 0;
    Object.keys(obj).forEach((key) => {
      if (key.length > maxLen && Object.prototype.hasOwnProperty.call(obj, key)) {
        maxLen = key.length;
      }
    });
    return maxLen;
  }
  var maxUnopLen = getMaxKeyLen(unaryOps);
  var maxBinopLen = getMaxKeyLen(binaryOps);
  var literals = {
    true: true,
    false: false,
    null: null,
    undefined: void 0
  };
  var thisStr = "this";
  function binaryPrecedence(opVal) {
    return binaryOps[opVal] || 0;
  }
  function createBinaryExpression(operator, left, right, location) {
    let type;
    if (operator === "||" || operator === "&&") {
      type = "LogicalExpression";
    } else if (operator === "=") {
      type = "Assignment";
    } else if (operator === "+=" || operator === "-=" || operator === "&=" || operator === "|=") {
      type = "Modification";
    } else {
      type = "BinaryExpression";
    }
    return {
      __id: ExpNodeOpaqueIdentifier,
      type,
      operator,
      left,
      right,
      location
    };
  }
  function isDecimalDigit(ch) {
    return ch >= 48 && ch <= 57;
  }
  function isIdentifierStart(ch) {
    return ch === 36 || ch === 95 || // `$` and `_`
    ch >= 65 && ch <= 90 || // A...Z
    ch >= 97 && ch <= 122;
  }
  function isIdentifierPart(ch) {
    return ch === 36 || ch === 95 || // `$` and `_`
    ch >= 65 && ch <= 90 || // A...Z
    ch >= 97 && ch <= 122 || // A...z
    ch >= 48 && ch <= 57;
  }
  function isModelRefStart(ch0, ch1) {
    return ch0 === OCURL_CODE && ch1 === OCURL_CODE;
  }
  function parseExpression(expr, options) {
    const strictMode = options?.strict ?? true;
    const charAtFunc = expr.charAt;
    const charCodeAtFunc = expr.charCodeAt;
    const { length } = expr;
    let index = 0;
    const getLocation = (startChar) => {
      return {
        start: {
          character: startChar
        },
        end: {
          character: index
        }
      };
    };
    function exprI(i) {
      return charAtFunc.call(expr, i);
    }
    function exprICode(i) {
      return charCodeAtFunc.call(expr, i);
    }
    function gobbleObjects() {
      const attributes = [];
      let closed = false;
      let shouldDefineKey = true;
      let key;
      let value;
      let chCode;
      const startCharIndex = index;
      ++index;
      while (index < length) {
        gobbleSpaces();
        chCode = exprICode(index);
        if (chCode === CCURL_CODE) {
          if (key) {
            throwError("A key was defined but a value was not", index);
          }
          index++;
          closed = true;
          break;
        } else if (shouldDefineKey) {
          if (chCode !== SQUOTE_CODE && chCode !== DQUOTE_CODE) {
            throwError("An object must start wtih a key", index);
          }
          key = gobbleStringLiteral();
          gobbleSpaces();
          if (exprICode(index) === COLON_CODE) {
            index++;
            shouldDefineKey = false;
          } else {
            throwError("A colon must follow an object key", index);
          }
        } else {
          value = gobbleExpression();
          attributes.push({ key, value });
          gobbleSpaces();
          chCode = exprICode(index);
          if (chCode === COMMA_CODE) {
            index++;
          } else if (chCode !== CCURL_CODE) {
            throwError("Please add a comma to add another key", index);
          }
          shouldDefineKey = true;
          key = void 0;
          value = void 0;
        }
        chCode = exprICode(index);
      }
      if (!closed) {
        throwError(`Unclosed brace in object`, index);
      }
      return {
        __id: ExpNodeOpaqueIdentifier,
        type: "Object",
        attributes,
        location: getLocation(startCharIndex)
      };
    }
    function gobbleSpaces() {
      let ch = exprICode(index);
      while (ch === 32 || ch === 9) {
        ch = exprICode(++index);
      }
    }
    function gobbleExpression() {
      const test = gobbleBinaryExpression();
      gobbleSpaces();
      const startCharIndex = index;
      if (index < length && exprICode(index) === QUMARK_CODE) {
        index++;
        const consequent = gobbleExpression();
        if (!consequent) {
          throwError("Expected expression", index);
        }
        gobbleSpaces();
        if (exprICode(index) === COLON_CODE) {
          index++;
          const alternate = gobbleExpression();
          if (!alternate) {
            throwError("Expected expression", index);
          }
          return {
            __id: ExpNodeOpaqueIdentifier,
            type: "ConditionalExpression",
            test,
            consequent,
            alternate,
            location: getLocation(startCharIndex)
          };
        }
        throwError("Expected :", index);
      }
      return test;
    }
    function gobbleBinaryOp() {
      gobbleSpaces();
      let toCheck = expr.substr(index, maxBinopLen);
      let tcLen = toCheck.length;
      while (tcLen > 0) {
        if (Object.prototype.hasOwnProperty.call(binaryOps, toCheck)) {
          index += tcLen;
          return toCheck;
        }
        toCheck = toCheck.substr(0, --tcLen);
      }
      return false;
    }
    function gobbleBinaryExpression() {
      let node;
      let prec;
      let i;
      let left = gobbleToken();
      let biop = gobbleBinaryOp();
      if (!biop) {
        return left;
      }
      let biopInfo = { value: biop, prec: binaryPrecedence(biop) };
      let right = gobbleToken();
      if (!right) {
        throwError(`Expected expression after ${biop}`, index);
      }
      const stack = [left, biopInfo, right];
      biop = gobbleBinaryOp();
      while (biop) {
        prec = binaryPrecedence(biop);
        if (prec === 0) {
          break;
        }
        biopInfo = { value: biop, prec };
        while (stack.length > 2 && prec <= stack[stack.length - 2].prec) {
          right = stack.pop();
          biop = stack.pop().value;
          left = stack.pop();
          node = createBinaryExpression(
            biop,
            left,
            right,
            createSpanningLocation(left.location, right.location)
          );
          stack.push(node);
        }
        node = gobbleToken();
        if (!node) {
          throwError(`Expected expression after ${biop}`, index);
        }
        stack.push(biopInfo, node);
        biop = gobbleBinaryOp();
      }
      i = stack.length - 1;
      node = stack[i];
      while (i > 1) {
        node = createBinaryExpression(
          stack[i - 1].value,
          stack[i - 2],
          node,
          createSpanningLocation(stack[i - 2].location, node.location)
        );
        i -= 2;
      }
      return node;
    }
    function gobbleToken() {
      gobbleSpaces();
      const ch = exprICode(index);
      const startCharIndex = index;
      if (isDecimalDigit(ch) || ch === PERIOD_CODE) {
        return gobbleNumericLiteral();
      }
      if (ch === SQUOTE_CODE || ch === DQUOTE_CODE) {
        return gobbleStringLiteral();
      }
      if (isIdentifierStart(ch) || ch === OPAREN_CODE) {
        return gobbleVariable();
      }
      if (ch === OBRACK_CODE) {
        return gobbleArray();
      }
      if (isModelRefStart(ch, exprICode(index + 1))) {
        return gobbleModelRef();
      }
      if (ch === OCURL_CODE) {
        return gobbleObjects();
      }
      let toCheck = expr.substr(index, maxUnopLen);
      let tcLen = toCheck.length;
      while (tcLen > 0) {
        if (Object.prototype.hasOwnProperty.call(unaryOps, toCheck)) {
          index += tcLen;
          return {
            __id: ExpNodeOpaqueIdentifier,
            type: "UnaryExpression",
            operator: toCheck,
            argument: gobbleToken(),
            prefix: true,
            location: getLocation(startCharIndex)
          };
        }
        toCheck = toCheck.substr(0, --tcLen);
      }
      return false;
    }
    function gobbleNumericLiteral() {
      let num = "";
      const startCharIndex = index;
      while (isDecimalDigit(exprICode(index))) {
        num += exprI(index++);
      }
      if (exprICode(index) === PERIOD_CODE) {
        num += exprI(index++);
        while (isDecimalDigit(exprICode(index))) {
          num += exprI(index++);
        }
      }
      let ch = exprI(index);
      if (ch === "e" || ch === "E") {
        num += exprI(index++);
        ch = exprI(index);
        if (ch === "+" || ch === "-") {
          num += exprI(index++);
        }
        while (isDecimalDigit(exprICode(index))) {
          num += exprI(index++);
        }
        if (!isDecimalDigit(exprICode(index - 1))) {
          throwError(`Expected exponent (${num}${exprI(index)})`, index);
        }
      }
      const chCode = exprICode(index);
      if (isIdentifierStart(chCode)) {
        throwError(
          `Variable names cannot start with a number (${num}${exprI(index)})`,
          index
        );
      } else if (chCode === PERIOD_CODE) {
        throwError("Unexpected period", index);
      }
      return {
        __id: ExpNodeOpaqueIdentifier,
        type: "Literal",
        value: parseFloat(num),
        raw: num,
        location: getLocation(startCharIndex)
      };
    }
    function gobbleStringLiteral() {
      const quote = exprI(index++);
      let str = "";
      let closed = false;
      const startCharIndex = index;
      while (index < length) {
        let ch = exprI(index++);
        if (ch === quote) {
          closed = true;
          break;
        }
        if (ch !== "\\") {
          str += ch;
          continue;
        }
        ch = exprI(index++);
        switch (ch) {
          case "n":
            str += "\n";
            break;
          case "r":
            str += "\r";
            break;
          case "t":
            str += "	";
            break;
          case "b":
            str += "\b";
            break;
          case "f":
            str += "\f";
            break;
          case "v":
            str += "\v";
            break;
          default:
        }
      }
      if (!closed) {
        throwError(`Unclosed quote after "${str}"`, index);
      }
      return {
        __id: ExpNodeOpaqueIdentifier,
        type: "Literal",
        value: str,
        raw: `${quote}${str}${quote}`,
        location: getLocation(startCharIndex)
      };
    }
    function gobbleModelRef() {
      let str = "";
      let closed = false;
      let openBraceCount = 1;
      const startCharIndex = index;
      index += 2;
      while (index < length) {
        const ch = exprI(index++);
        if (ch === "}" && exprICode(index) === CCURL_CODE) {
          index++;
          openBraceCount--;
          if (openBraceCount === 0) {
            closed = true;
            break;
          }
          str += "}}";
        } else if (ch === "{" && exprICode(index) === OCURL_CODE) {
          openBraceCount++;
          str += "{{";
          index++;
        } else {
          str += ch;
        }
      }
      if (!closed) {
        throwError(`Unclosed brace after "${str}"`, index);
      }
      return {
        __id: ExpNodeOpaqueIdentifier,
        type: "ModelRef",
        ref: str,
        location: getLocation(startCharIndex)
      };
    }
    function gobbleIdentifier() {
      const start = index;
      let ch = exprICode(start);
      if (isIdentifierStart(ch)) {
        index++;
      } else {
        throwError(`Unexpected ${exprI(index)}`, index);
      }
      while (index < length) {
        ch = exprICode(index);
        if (isIdentifierPart(ch)) {
          index++;
        } else {
          break;
        }
      }
      const identifier = expr.slice(start, index);
      if (Object.prototype.hasOwnProperty.call(literals, identifier)) {
        return {
          __id: ExpNodeOpaqueIdentifier,
          type: "Literal",
          value: literals[identifier],
          raw: identifier,
          location: getLocation(start)
        };
      }
      if (identifier === thisStr) {
        return {
          __id: ExpNodeOpaqueIdentifier,
          type: "ThisExpression",
          location: getLocation(start)
        };
      }
      return {
        __id: ExpNodeOpaqueIdentifier,
        type: "Identifier",
        name: identifier,
        location: getLocation(start)
      };
    }
    function gobbleArguments(termination) {
      const args = [];
      let charIndex;
      let node;
      while (index < length) {
        gobbleSpaces();
        charIndex = exprICode(index);
        if (charIndex === termination) {
          index++;
          break;
        }
        if (charIndex === COMMA_CODE) {
          index++;
          continue;
        }
        node = gobbleExpression();
        if (!node || node.type === "Compound") {
          throwError("Expected comma", index);
        }
        args.push(node);
      }
      if (strictMode && charIndex !== termination) {
        throwError(`Expected ${String.fromCharCode(termination)}`, index);
      }
      return args;
    }
    function gobbleVariable() {
      let charIndex = exprICode(index);
      let node = charIndex === OPAREN_CODE ? gobbleGroup() : gobbleIdentifier();
      const startCharIndex = index;
      gobbleSpaces();
      charIndex = exprICode(index);
      while (charIndex === PERIOD_CODE || charIndex === OBRACK_CODE || charIndex === OPAREN_CODE) {
        index++;
        if (charIndex === PERIOD_CODE) {
          gobbleSpaces();
          node = {
            __id: ExpNodeOpaqueIdentifier,
            type: "MemberExpression",
            computed: false,
            object: node,
            property: gobbleIdentifier(),
            location: getLocation(startCharIndex)
          };
        } else if (charIndex === OBRACK_CODE) {
          node = {
            __id: ExpNodeOpaqueIdentifier,
            type: "MemberExpression",
            computed: true,
            object: node,
            property: gobbleExpression(),
            location: getLocation(startCharIndex)
          };
          gobbleSpaces();
          charIndex = exprICode(index);
          if (charIndex !== CBRACK_CODE) {
            throwError("Unclosed [", index);
          }
          index++;
        } else if (charIndex === OPAREN_CODE) {
          node = {
            __id: ExpNodeOpaqueIdentifier,
            type: "CallExpression",
            args: gobbleArguments(CPAREN_CODE),
            callTarget: node,
            location: getLocation(startCharIndex)
          };
        }
        gobbleSpaces();
        charIndex = exprICode(index);
      }
      return node;
    }
    function gobbleGroup() {
      index++;
      const node = gobbleExpression();
      gobbleSpaces();
      if (exprICode(index) === CPAREN_CODE) {
        index++;
        return node;
      }
      throwError("Unclosed (", index);
    }
    function gobbleArray() {
      const startCharIndex = index;
      index++;
      return {
        __id: ExpNodeOpaqueIdentifier,
        type: "ArrayExpression",
        elements: gobbleArguments(CBRACK_CODE),
        location: getLocation(startCharIndex)
      };
    }
    const nodes = [];
    try {
      while (index < length) {
        const chIndex = exprICode(index);
        if (chIndex === SEMCOL_CODE || chIndex === COMMA_CODE) {
          index++;
          continue;
        }
        const node = gobbleExpression();
        if (node) {
          nodes.push(node);
        } else if (strictMode && index < length) {
          throwError(`Unexpected "${exprI(index)}"`, index);
        }
      }
      if (nodes.length === 1) {
        return nodes[0];
      }
      return {
        __id: ExpNodeOpaqueIdentifier,
        type: "Compound",
        body: nodes,
        location: getLocation(0)
      };
    } catch (e) {
      if (strictMode || !(e instanceof Error)) {
        throw e;
      }
      return {
        __id: ExpNodeOpaqueIdentifier,
        type: "Compound",
        body: nodes,
        location: getLocation(0),
        error: e
      };
    }
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/expressions/evaluator-functions.ts
  var evaluator_functions_exports = {};
  __export(evaluator_functions_exports, {
    conditional: () => conditional,
    deleteDataVal: () => deleteDataVal,
    getDataVal: () => getDataVal,
    setDataVal: () => setDataVal,
    waitFor: () => waitFor
  });

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/expressions/async.ts
  function isPromiseLike(value) {
    return value != null && typeof value === "object" && typeof value.then === "function" && // Additional safeguards against false positives
    (value instanceof Promise || // Check for standard Promise constructor name
    value.constructor?.name === "Promise" || // Verify it has other Promise-like methods to reduce false positives
    typeof value.catch === "function" && typeof value.finally === "function");
  }
  var AwaitableSymbol = Symbol("Awaitable");
  function isAwaitable(val) {
    return isPromiseLike(val) && val[AwaitableSymbol] !== void 0;
  }
  function collateAwaitable(promises) {
    const result = Promise.all(promises);
    return makeAwaitable(result);
  }
  function makeAwaitable(promise) {
    promise[AwaitableSymbol] = AwaitableSymbol;
    promise.awaitableThen = (arg) => {
      return makeAwaitable(promise.then(arg));
    };
    return promise;
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/expressions/evaluator-functions.ts
  var setDataVal = (_context, binding, value) => {
    _context.model.set([[binding, value]]);
  };
  var getDataVal = (_context, binding) => {
    return _context.model.get(binding);
  };
  var deleteDataVal = (_context, binding) => {
    return _context.model.delete(binding);
  };
  var conditional = (ctx, condition, ifTrue, ifFalse) => {
    const testResult = ctx.evaluate(condition);
    if (isAwaitable(testResult)) {
      return testResult.awaitableThen((resolvedTest) => {
        if (resolvedTest) {
          return ctx.evaluate(ifTrue);
        }
        if (ifFalse) {
          return ctx.evaluate(ifFalse);
        }
        return null;
      });
    }
    if (testResult) {
      return ctx.evaluate(ifTrue);
    }
    if (ifFalse) {
      return ctx.evaluate(ifFalse);
    }
    return null;
  };
  conditional.resolveParams = false;
  var waitFor = (ctx, promise) => {
    return makeAwaitable(promise);
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/expressions/utils.ts
  function withoutContext(fn) {
    return (_context, ...args) => fn(...args);
  }
  function isInRange(position, location) {
    return position.character >= location.start.character && position.character <= location.end.character;
  }
  function findClosestNodeAtPosition(node, position) {
    switch (node.type) {
      case "Modification":
      case "Assignment":
      case "LogicalExpression":
      case "BinaryExpression": {
        const check = findClosestNodeAtPosition(node.left, position) ?? findClosestNodeAtPosition(node.right, position);
        if (check) {
          return check;
        }
        break;
      }
      case "UnaryExpression": {
        const checkArg = findClosestNodeAtPosition(node.argument, position);
        if (checkArg) {
          return checkArg;
        }
        break;
      }
      case "MemberExpression": {
        const checkObject = findClosestNodeAtPosition(node.object, position) ?? findClosestNodeAtPosition(node.property, position);
        if (checkObject) {
          return checkObject;
        }
        break;
      }
      case "ConditionalExpression": {
        const checkObject = findClosestNodeAtPosition(node.test, position) ?? findClosestNodeAtPosition(node.consequent, position) ?? findClosestNodeAtPosition(node.alternate, position);
        if (checkObject) {
          return checkObject;
        }
        break;
      }
      case "ArrayExpression":
      case "Compound": {
        const elements = node.type === "ArrayExpression" ? node.elements : node.body;
        const anyElements = elements.find(
          (e) => findClosestNodeAtPosition(e, position)
        );
        if (anyElements) {
          return anyElements;
        }
        break;
      }
      case "Object": {
        const checkObject = node.attributes.reduce(
          (found, next) => {
            return found ?? findClosestNodeAtPosition(next.key, position) ?? findClosestNodeAtPosition(next.value, position);
          },
          void 0
        );
        if (checkObject) {
          return checkObject;
        }
        break;
      }
      case "CallExpression": {
        const anyArgs = node.args.find((arg) => {
          return findClosestNodeAtPosition(arg, position);
        }) ?? findClosestNodeAtPosition(node.callTarget, position);
        if (anyArgs) {
          return anyArgs;
        }
        break;
      }
    }
    if (node.location && isInRange(position, node.location)) {
      return node;
    }
  }
  function isObjectExpression(expr) {
    if (isExpressionNode(expr)) {
      return false;
    }
    return typeof expr === "object" && expr !== null && !Array.isArray(expr) && "value" in expr;
  }
  function isErrorWithLocation(error) {
    return error.index !== void 0 && error.description !== void 0;
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/expressions/evaluator.ts
  var andandOperator = (ctx, a, b, async) => {
    return LogicalOperators.and(ctx, a, b, async);
  };
  andandOperator.resolveParams = false;
  var ororOperator = (ctx, a, b, async) => {
    return LogicalOperators.or(ctx, a, b, async);
  };
  ororOperator.resolveParams = false;
  var DEFAULT_BINARY_OPERATORS = {
    // TODO: A lot of these functions used to do type coercion. Not sure if we want to keep that behavior or not.
    "+": (a, b) => a + b,
    "-": (a, b) => a - b,
    "*": (a, b) => a * b,
    "/": (a, b) => a / b,
    "%": (a, b) => a % b,
    // Promise-aware comparison operators
    // eslint-disable-next-line
    "==": makePromiseAwareBinaryOp((a, b) => a == b),
    // eslint-disable-next-line
    "!=": makePromiseAwareBinaryOp((a, b) => a != b),
    ">": makePromiseAwareBinaryOp((a, b) => a > b),
    ">=": makePromiseAwareBinaryOp((a, b) => a >= b),
    "<": makePromiseAwareBinaryOp((a, b) => a < b),
    "<=": makePromiseAwareBinaryOp((a, b) => a <= b),
    "!==": makePromiseAwareBinaryOp((a, b) => a !== b),
    "===": makePromiseAwareBinaryOp((a, b) => a === b),
    "&&": andandOperator,
    "||": ororOperator,
    // eslint-disable-next-line
    "|": (a, b) => a | b,
    // eslint-disable-next-line
    "&": (a, b) => a & b,
    "+=": (a, b) => a + b,
    "-=": (a, b) => a - b,
    // eslint-disable-next-line
    "&=": (a, b) => a & b,
    // eslint-disable-next-line
    "|=": (a, b) => a | b
  };
  var DEFAULT_UNARY_OPERATORS = {
    "-": (a) => -a,
    "+": (a) => Number(a),
    "!": makePromiseAwareUnaryOp((a) => !a)
  };
  function makePromiseAwareBinaryOp(operation) {
    return (a, b, async) => {
      if (async && (isAwaitable(a) || isAwaitable(b))) {
        return collateAwaitable([
          Promise.resolve(a),
          Promise.resolve(b)
        ]).awaitableThen(
          ([resolvedA, resolvedB]) => operation(resolvedA, resolvedB)
        );
      }
      return operation(a, b);
    };
  }
  function makePromiseAwareUnaryOp(operation) {
    return (a, async) => {
      if (async && isAwaitable(a)) {
        return a.awaitableThen((resolved) => operation(resolved));
      }
      return operation(a);
    };
  }
  function handleConditionalBranching(testValue, getTrueBranch, getFalseBranch, resolveNode, async) {
    if (async && isAwaitable(testValue)) {
      return testValue.awaitableThen((resolved) => {
        const branch2 = resolved ? getTrueBranch() : getFalseBranch();
        const branchResult = resolveNode(branch2);
        return isAwaitable(branchResult) ? Promise.resolve(branchResult) : branchResult;
      });
    }
    const branch = testValue ? getTrueBranch() : getFalseBranch();
    return resolveNode(branch);
  }
  var PromiseCollectionHandler = {
    /**
     * Handle array with potential Promise elements
     */
    handleArray(items, async) {
      if (!async) {
        return items;
      }
      const hasPromises = items.some((item) => isAwaitable(item));
      return hasPromises ? collateAwaitable(items) : items;
    },
    /**
     * Handle object with potential Promise keys/values
     */
    handleObject(attributes, resolveNode, async) {
      const resolvedAttributes = {};
      const promises = [];
      let hasPromises = false;
      attributes.forEach((attr) => {
        const key = resolveNode(attr.key);
        const value = resolveNode(attr.value);
        if (async && (isAwaitable(key) || isAwaitable(value))) {
          hasPromises = true;
          const keyPromise = Promise.resolve(key);
          const valuePromise = Promise.resolve(value);
          promises.push(
            collateAwaitable([keyPromise, valuePromise]).awaitableThen(
              ([resolvedKey, resolvedValue]) => {
                resolvedAttributes[resolvedKey] = resolvedValue;
              }
            )
          );
        } else {
          resolvedAttributes[key] = value;
        }
      });
      return hasPromises ? collateAwaitable(promises).awaitableThen(() => resolvedAttributes) : resolvedAttributes;
    }
  };
  var LogicalOperators = {
    and: (ctx, leftNode, rightNode, async) => {
      const leftResult = ctx.evaluate(leftNode);
      if (async && isAwaitable(leftResult)) {
        return leftResult.awaitableThen((awaitedLeft) => {
          if (!awaitedLeft)
            return awaitedLeft;
          const rightResult = ctx.evaluate(rightNode);
          return isAwaitable(rightResult) ? rightResult : Promise.resolve(rightResult);
        });
      }
      return leftResult && ctx.evaluate(rightNode);
    },
    or: (ctx, leftNode, rightNode, async) => {
      const leftResult = ctx.evaluate(leftNode);
      if (async && isAwaitable(leftResult)) {
        return leftResult.awaitableThen((awaitedLeft) => {
          if (awaitedLeft)
            return awaitedLeft;
          const rightResult = ctx.evaluate(rightNode);
          return isAwaitable(rightResult) ? rightResult : Promise.resolve(rightResult);
        });
      }
      return leftResult || ctx.evaluate(rightNode);
    }
  };
  var ExpressionEvaluator = class {
    constructor(defaultOptions) {
      this.vars = {};
      this.hooks = {
        /** Resolve an AST node for an expression to a value */
        resolve: new SyncWaterfallHook(),
        /** Gets the options that will be passed in calls to the resolve hook */
        resolveOptions: new SyncWaterfallHook(),
        /** Allows users to change the expression to be evaluated before processing */
        beforeEvaluate: new SyncWaterfallHook(),
        /**
         * An optional means of handling an error in the expression execution
         * Return true if handled, to stop propagation of the error
         */
        onError: new SyncBailHook()
      };
      this.expressionsCache = /* @__PURE__ */ new Map();
      this.operators = {
        binary: new Map(
          Object.entries(DEFAULT_BINARY_OPERATORS)
        ),
        unary: new Map(
          Object.entries(DEFAULT_UNARY_OPERATORS)
        ),
        expressions: new Map([
          ...Object.entries(evaluator_functions_exports),
          ["await", waitFor]
        ])
      };
      this.defaultHookOptions = {
        ...defaultOptions,
        evaluate: (expr) => this.evaluate(expr, this.defaultHookOptions),
        resolveNode: (node) => this._execAST(node, this.defaultHookOptions)
      };
      this.hooks.resolve.tap("ExpressionEvaluator", (result, node, options) => {
        return this._resolveNode(result, node, options);
      });
      this.evaluate = this.evaluate.bind(this);
    }
    reset() {
      this.expressionsCache.clear();
    }
    evaluate(expr, options) {
      const resolvedOpts = this.hooks.resolveOptions.call({
        ...this.defaultHookOptions,
        ...options,
        resolveNode: (node) => this._execAST(node, resolvedOpts)
      });
      let expression = this.hooks.beforeEvaluate.call(expr, resolvedOpts) ?? expr;
      while (isObjectExpression(expression)) {
        expression = expression.value;
      }
      if (typeof expression === "number" || typeof expression === "boolean" || expression === void 0 || expression === null) {
        return expression;
      }
      if (isExpressionNode(expression)) {
        return this._execAST(expression, resolvedOpts);
      }
      if (Array.isArray(expression)) {
        return expression.reduce(
          (_nothing, exp) => this.evaluate(exp, options),
          null
        );
      }
      return this._execString(String(expression), resolvedOpts);
    }
    /**
     * Evaluate functions in an async context
     * @experimental These Player APIs are in active development and may change. Use with caution
     */
    evaluateAsync(expr, options) {
      if (Array.isArray(expr)) {
        return collateAwaitable(
          expr.map(
            async (exp) => this.evaluate(exp, { ...options, async: true })
          )
        ).awaitableThen((values) => {
          return values.pop();
        });
      } else {
        return this.evaluate(expr, { ...options, async: true });
      }
    }
    addExpressionFunction(name, handler) {
      this.operators.expressions.set(name, handler);
    }
    addBinaryOperator(operator, handler) {
      this.operators.binary.set(operator, handler);
    }
    addUnaryOperator(operator, handler) {
      this.operators.unary.set(operator, handler);
    }
    setExpressionVariable(name, value) {
      this.vars[name] = value;
    }
    getExpressionVariable(name) {
      return this.vars[name];
    }
    _execAST(node, options) {
      return this.hooks.resolve.call(void 0, node, options);
    }
    _execString(exp, options) {
      if (exp === "") {
        return exp;
      }
      const matches = exp.match(/^@\[(.*)\]@$/);
      let matchedExp = exp;
      if (matches) {
        const [, matched] = Array.from(matches);
        if (matched) {
          matchedExp = matched;
        }
      }
      let storedAST;
      try {
        storedAST = this.expressionsCache.get(matchedExp) ?? parseExpression(matchedExp, { strict: options.strict });
        this.expressionsCache.set(matchedExp, storedAST);
      } catch (e) {
        if (options.throwErrors || !this.hooks.onError.call(e)) {
          throw new import_ts_nested_error3.NestedError(`Error parsing expression: ${exp}`, e);
        }
        return;
      }
      try {
        return this._execAST(storedAST, options);
      } catch (e) {
        if (options.throwErrors || !this.hooks.onError.call(e)) {
          throw new import_ts_nested_error3.NestedError(`Error evaluating expression: ${exp}`, e);
        }
      }
    }
    _resolveNode(_currentValue, node, options) {
      const { resolveNode, model } = options;
      const isAsync = options.async ?? false;
      const expressionContext = {
        ...options,
        evaluate: (expr) => this.evaluate(expr, options)
      };
      if (node.type === "Literal") {
        return node.value;
      }
      if (node.type === "Identifier") {
        return this.vars[node.name];
      }
      if (node.type === "Compound" || node.type === "ThisExpression") {
        throw new Error(`Expression type: ${node.type} is not supported`);
      }
      if (node.type === "BinaryExpression" || node.type === "LogicalExpression") {
        const operator = this.operators.binary.get(node.operator);
        if (operator) {
          if ("resolveParams" in operator) {
            if (operator.resolveParams === false) {
              return operator(expressionContext, node.left, node.right, isAsync);
            }
            const left2 = resolveNode(node.left);
            const right2 = resolveNode(node.right);
            if (options.async && (isAwaitable(left2) || isAwaitable(right2))) {
              return collateAwaitable([left2, right2]).awaitableThen(
                ([leftVal, rightVal]) => operator(expressionContext, leftVal, rightVal, isAsync)
              );
            }
            return operator(expressionContext, left2, right2, isAsync);
          }
          const left = resolveNode(node.left);
          const right = resolveNode(node.right);
          if (options.async && (isAwaitable(left) || isAwaitable(right))) {
            return collateAwaitable([left, right]).awaitableThen(
              ([leftVal, rightVal]) => operator(leftVal, rightVal, isAsync)
            );
          }
          return operator(left, right, isAsync);
        }
        return;
      }
      if (node.type === "UnaryExpression") {
        const operator = this.operators.unary.get(node.operator);
        if (operator) {
          if ("resolveParams" in operator) {
            if (operator.resolveParams === false) {
              return operator(expressionContext, node.argument, isAsync);
            }
            const arg2 = resolveNode(node.argument);
            if (options.async && isAwaitable(arg2)) {
              return arg2.awaitableThen(
                (argVal) => operator(expressionContext, argVal, isAsync)
              );
            }
            return operator(expressionContext, arg2, isAsync);
          }
          const arg = resolveNode(node.argument);
          if (options.async && isAwaitable(arg)) {
            return arg.awaitableThen((argVal) => operator(argVal, isAsync));
          }
          return operator(arg, isAsync);
        }
        return;
      }
      if (node.type === "Object") {
        return PromiseCollectionHandler.handleObject(
          node.attributes,
          resolveNode,
          options.async || false
        );
      }
      if (node.type === "CallExpression") {
        const expressionName = node.callTarget.name;
        const operator = this.operators.expressions.get(expressionName);
        if (!operator) {
          throw new Error(`Unknown expression function: ${expressionName}`);
        }
        if (operator.name === waitFor.name && !options.async) {
          throw new Error("Usage of await outside of async context");
        }
        if ("resolveParams" in operator && operator.resolveParams === false) {
          return operator(expressionContext, ...node.args);
        }
        const args = node.args.map((n) => resolveNode(n));
        if (options.async) {
          const hasPromises = args.some(isAwaitable);
          if (hasPromises) {
            return collateAwaitable(args).awaitableThen(
              (resolvedArgs) => operator(expressionContext, ...resolvedArgs)
            );
          }
        }
        return operator(expressionContext, ...args);
      }
      if (node.type === "ModelRef") {
        return model.get(node.ref, { context: { model: options.model } });
      }
      if (node.type === "MemberExpression") {
        const obj = resolveNode(node.object);
        const prop = resolveNode(node.property);
        if (options.async && (isAwaitable(obj) || isAwaitable(prop))) {
          return collateAwaitable([obj, prop]).awaitableThen(
            ([objVal, propVal]) => objVal[propVal]
          );
        }
        return obj[prop];
      }
      if (node.type === "Assignment") {
        if (node.left.type === "ModelRef") {
          const value = resolveNode(node.right);
          if (isPromiseLike(value)) {
            if (options.async && isAwaitable(value)) {
              return value.awaitableThen((resolvedValue) => {
                model.set([[node.left.ref, resolvedValue]]);
                return resolvedValue;
              });
            } else {
              options.logger?.warn(
                "Unawaited promise written to mode, this behavior is undefined and may change in future releases"
              );
            }
          }
          model.set([[node.left.ref, value]]);
          return value;
        }
        if (node.left.type === "Identifier") {
          const value = resolveNode(node.right);
          if (options.async && isAwaitable(value)) {
            return value.awaitableThen((resolvedValue) => {
              this.vars[node.left.name] = resolvedValue;
              return resolvedValue;
            });
          }
          this.vars[node.left.name] = value;
          return value;
        }
        return;
      }
      if (node.type === "ConditionalExpression") {
        const testResult = resolveNode(node.test);
        return handleConditionalBranching(
          testResult,
          () => node.consequent,
          () => node.alternate,
          resolveNode,
          isAsync
        );
      }
      if (node.type === "ArrayExpression") {
        const results = node.elements.map((ele) => resolveNode(ele));
        return PromiseCollectionHandler.handleArray(results, isAsync);
      }
      if (node.type === "Modification") {
        const operation = this.operators.binary.get(node.operator);
        if (operation) {
          let newValue;
          if ("resolveParams" in operation) {
            if (operation.resolveParams === false) {
              newValue = operation(
                expressionContext,
                node.left,
                node.right,
                isAsync
              );
            } else {
              const left = resolveNode(node.left);
              const right = resolveNode(node.right);
              if (options.async && (isAwaitable(left) || isAwaitable(right))) {
                newValue = collateAwaitable([left, right]).awaitableThen(
                  ([leftVal, rightVal]) => operation(expressionContext, leftVal, rightVal, isAsync)
                );
              } else {
                newValue = operation(expressionContext, left, right, isAsync);
              }
            }
          } else {
            const left = resolveNode(node.left);
            const right = resolveNode(node.right);
            if (options.async && (isAwaitable(left) || isAwaitable(right))) {
              newValue = collateAwaitable([left, right]).awaitableThen(
                ([leftVal, rightVal]) => operation(leftVal, rightVal, isAsync)
              );
            } else {
              newValue = operation(left, right, isAsync);
            }
          }
          if (node.left.type === "ModelRef") {
            if (options.async && isAwaitable(newValue)) {
              return newValue.awaitableThen((resolvedValue) => {
                model.set([[node.left.ref, resolvedValue]]);
                return resolvedValue;
              });
            }
            model.set([[node.left.ref, newValue]]);
          } else if (node.left.type === "Identifier") {
            if (options.async && isAwaitable(newValue)) {
              return newValue.awaitableThen((resolvedValue) => {
                this.vars[node.left.name] = resolvedValue;
                return resolvedValue;
              });
            }
            this.vars[node.left.name] = newValue;
          }
          return newValue;
        }
        return resolveNode(node.left);
      }
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/logger/types.ts
  var severities = ["trace", "debug", "info", "warn", "error"];

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/logger/consoleLogger.ts
  var ConsoleLogger = class {
    constructor(severity = "warn", _console = console) {
      this.trace = this.createHandler("trace");
      this.debug = this.createHandler("debug");
      this.info = this.createHandler("info");
      this.warn = this.createHandler("warn");
      this.error = this.createHandler("error");
      this.severity = severity;
      this._console = _console;
    }
    setSeverity(severity) {
      this.severity = severity;
    }
    getConsoleFn(severity) {
      switch (severities.indexOf(severity)) {
        case 0:
        case 1:
        case 2:
          return this._console.log;
        case 3:
          return this._console.warn;
        default:
          return this._console.error;
      }
    }
    createHandler(severity) {
      return (...args) => {
        const sevIndex = severities.indexOf(severity);
        const sevConf = severities.indexOf(this.severity);
        if (sevIndex >= sevConf) {
          this.getConsoleFn(severity)(`player - ${severity} -`, ...args);
        }
      };
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/logger/noopLogger.ts
  var noop = () => {
  };
  var NoopLogger = class {
    constructor() {
      this.trace = noop;
      this.debug = noop;
      this.info = noop;
      this.warn = noop;
      this.error = noop;
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/logger/tapableLogger.ts
  var TapableLogger = class {
    constructor() {
      this.hooks = {
        trace: new SyncHook(),
        debug: new SyncHook(),
        info: new SyncHook(),
        warn: new SyncHook(),
        error: new SyncHook(),
        log: new SyncHook()
      };
      this.logHandlers = /* @__PURE__ */ new Set();
      this.trace = this.createHandler("trace");
      this.debug = this.createHandler("debug");
      this.info = this.createHandler("info");
      this.warn = this.createHandler("warn");
      this.error = this.createHandler("error");
    }
    createHandler(severity) {
      return (...args) => {
        this.hooks[severity].call(args);
        this.hooks.log.call(severity, args);
        this.logHandlers.forEach((logger) => logger[severity](...args));
      };
    }
    addHandler(logHandler) {
      this.logHandlers.add(logHandler);
    }
    removeHandler(logHandler) {
      this.logHandlers.delete(logHandler);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/logger/proxyLogger.ts
  var ProxyLogger = class {
    constructor(loggerProvider) {
      this.trace = this.createHandler("trace");
      this.debug = this.createHandler("debug");
      this.info = this.createHandler("info");
      this.warn = this.createHandler("warn");
      this.error = this.createHandler("error");
      this.proxiedLoggerProvider = loggerProvider;
    }
    createHandler(severity) {
      return (...args) => {
        const logger = this.proxiedLoggerProvider();
        logger?.[severity](...args);
      };
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/schema/schema.ts
  var identify = (val) => val;
  function parse2(schema) {
    const expandedPaths = /* @__PURE__ */ new Map();
    if (!schema.ROOT) {
      return expandedPaths;
    }
    const parseQueue = [{ node: schema.ROOT, path: [], visited: /* @__PURE__ */ new Set() }];
    while (parseQueue.length > 0) {
      const next = parseQueue.shift();
      if (!next) {
        break;
      }
      const { node, path, visited } = next;
      Object.entries(node).forEach(([prop, type]) => {
        const nestedPath = [...path, prop];
        const nestedPathStr = nestedPath.join(".");
        if (expandedPaths.has(nestedPathStr)) {
          throw new Error(
            "Path has already been processed. There's either a loop somewhere or a bug"
          );
        }
        if (visited.has(type.type)) {
          throw new Error(
            `Path already contained type: ${type.type}. This likely indicates a loop in the schema`
          );
        }
        expandedPaths.set(nestedPathStr, type);
        if (type.isArray) {
          nestedPath.push("[]");
        }
        if (type.isRecord) {
          nestedPath.push("{}");
        }
        if (type.type && schema[type.type]) {
          parseQueue.push({
            path: nestedPath,
            node: schema[type.type],
            visited: /* @__PURE__ */ new Set([...visited, type.type])
          });
        }
      });
    }
    return expandedPaths;
  }
  var SchemaController = class {
    constructor(schema) {
      this.formatters = /* @__PURE__ */ new Map();
      this.types = /* @__PURE__ */ new Map();
      this.schema = /* @__PURE__ */ new Map();
      this.bindingSchemaNormalizedCache = /* @__PURE__ */ new Map();
      this.hooks = {
        resolveTypeForBinding: new SyncWaterfallHook()
      };
      this.schema = schema ? parse2(schema) : /* @__PURE__ */ new Map();
    }
    addFormatters(fns) {
      fns.forEach((def) => {
        this.formatters.set(def.name, def);
      });
    }
    addDataTypes(types) {
      types.forEach((t2) => {
        this.types.set(t2.type, t2);
      });
    }
    getValidationsForBinding(binding) {
      const typeDef = this.getApparentType(binding);
      if (!typeDef?.validation?.length) {
        return void 0;
      }
      return typeDef.validation.map((vRef) => ({
        severity: "error",
        trigger: "change",
        ...vRef
      }));
    }
    normalizeBinding(binding) {
      const cached = this.bindingSchemaNormalizedCache.get(binding);
      if (cached) {
        return cached;
      }
      let bindingArray = binding.asArray();
      let normalized = bindingArray.map((p) => typeof p === "number" ? "[]" : p).join(".");
      if (normalized) {
        this.bindingSchemaNormalizedCache.set(binding, normalized);
        bindingArray = normalized.split(".");
      }
      bindingArray.forEach((item) => {
        const recordBinding = bindingArray.map((p) => p === item ? "{}" : p).join(".");
        if (this.schema.get(recordBinding)) {
          this.bindingSchemaNormalizedCache.set(binding, recordBinding);
          bindingArray = recordBinding.split(".");
          normalized = recordBinding;
        }
      });
      return normalized;
    }
    getType(binding) {
      return this.hooks.resolveTypeForBinding.call(
        this.schema.get(this.normalizeBinding(binding)),
        binding
      );
    }
    getApparentType(binding) {
      const schemaType = this.getType(binding);
      if (schemaType === void 0) {
        return void 0;
      }
      const baseType = this.getTypeDefinition(schemaType?.type);
      if (baseType === void 0) {
        return schemaType;
      }
      return {
        ...baseType,
        ...schemaType,
        validation: [
          ...schemaType.validation ?? [],
          ...baseType.validation ?? []
        ]
      };
    }
    getTypeDefinition(dataType) {
      return this.types.get(dataType);
    }
    getFormatterForType(formatReference) {
      const { type: formatType, ...options } = formatReference;
      const formatter = this.formatters.get(formatType);
      if (!formatter) {
        return;
      }
      return {
        format: formatter.format ? (val) => formatter.format?.(val, options) : identify,
        deformat: formatter.deformat ? (val) => formatter.deformat?.(val, options) : identify
      };
    }
    /**
     * Given a binding, fetch a function that's responsible for formatting, and/or de-formatting the data
     * If no formatter is registered, it will return undefined
     */
    getFormatter(binding) {
      const type = this.getApparentType(binding);
      if (!type?.format) {
        return void 0;
      }
      return this.getFormatterForType(type.format);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/string-resolver/index.ts
  var import_timm2 = __toESM(require_timm());
  var DOUBLE_OPEN_CURLY = "{{";
  var DOUBLE_CLOSE_CURLY = "}}";
  function findNextExp(str) {
    const expStart = str.indexOf(DOUBLE_OPEN_CURLY);
    if (expStart === -1) {
      return void 0;
    }
    let count = 1;
    let offset = expStart + DOUBLE_OPEN_CURLY.length;
    let workingString = str.substring(expStart + DOUBLE_OPEN_CURLY.length);
    while (count > 0 && workingString.length > 0) {
      const nextCloseCurly = workingString.indexOf(DOUBLE_CLOSE_CURLY);
      if (nextCloseCurly === -1) {
        break;
      }
      const nextOpenCurly = workingString.indexOf(DOUBLE_OPEN_CURLY);
      if (nextOpenCurly !== -1 && nextOpenCurly < nextCloseCurly) {
        count++;
        workingString = workingString.substring(
          nextOpenCurly + DOUBLE_OPEN_CURLY.length
        );
        offset += nextOpenCurly + DOUBLE_OPEN_CURLY.length;
      } else {
        count--;
        workingString = workingString.substring(
          nextCloseCurly + DOUBLE_CLOSE_CURLY.length
        );
        offset += nextCloseCurly + DOUBLE_CLOSE_CURLY.length;
      }
    }
    if (count !== 0) {
      throw new Error(`Unbalanced {{ and }} in exp: ${str}`);
    }
    return {
      start: expStart,
      end: offset
    };
  }
  function resolveExpressionsInString(val, { evaluate }) {
    if (!evaluate) {
      return val;
    }
    const expMatch = /@\[.*?\]@/;
    let newVal = val;
    let match = newVal.match(expMatch);
    while (match !== null) {
      const expStrWithBrackets = match[0];
      const matchStart = newVal.indexOf(expStrWithBrackets);
      const expString = expStrWithBrackets.substr(
        "@[".length,
        expStrWithBrackets.length - "@[".length - "]@".length
      );
      const expValue = evaluate(expString);
      if (matchStart === 0 && expStrWithBrackets === val && typeof expValue !== "string") {
        return expValue;
      }
      newVal = newVal.substr(0, matchStart) + expValue + newVal.substr(matchStart + expStrWithBrackets.length);
      match = newVal.match(expMatch);
    }
    return newVal;
  }
  function resolveDataRefsInString(val, options) {
    const { model, formatted = true } = options;
    let workingString = resolveExpressionsInString(val, options);
    if (!model || typeof workingString !== "string" || workingString.indexOf(DOUBLE_OPEN_CURLY) === -1) {
      return workingString;
    }
    while (workingString.indexOf(DOUBLE_OPEN_CURLY) !== -1) {
      const expLocation = findNextExp(workingString);
      if (!expLocation) {
        return workingString;
      }
      const { start, end } = expLocation;
      const binding = workingString.substring(
        start + DOUBLE_OPEN_CURLY.length,
        end - DOUBLE_OPEN_CURLY.length
      ).trim();
      const evaledVal = model.get(binding, { formatted });
      if (start === 0 && end === workingString.length && typeof evaledVal !== "string") {
        return evaledVal;
      }
      workingString = workingString.substr(0, start) + evaledVal + workingString.substr(end);
    }
    return workingString;
  }
  function traverseObject(val, options) {
    switch (typeof val) {
      case "string": {
        return resolveDataRefsInString(val, options);
      }
      case "object": {
        if (!val)
          return val;
        const keys = Object.keys(val);
        let newVal = val;
        if (keys.length > 0) {
          keys.forEach((key) => {
            newVal = (0, import_timm2.setIn)(
              newVal,
              [key],
              traverseObject(val[key], options)
            );
          });
        }
        return newVal;
      }
      default:
        return val;
    }
  }
  function resolveDataRefs(val, options) {
    return traverseObject(val, options);
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/validator/validation-middleware.ts
  var import_timm3 = __toESM(require_timm());

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/validator/binding-map-splice.ts
  function removeBindingAndChildrenFromMap(sourceMap, binding) {
    const targetMap = new Map(sourceMap);
    const parentBinding = binding.parent();
    const property = binding.key();
    targetMap.forEach((_value, trackedBinding) => {
      if (binding === trackedBinding || binding.contains(trackedBinding)) {
        targetMap.delete(trackedBinding);
      }
    });
    if (typeof property === "number") {
      const bindingsToRewrite = Array.from(sourceMap.keys()).filter((b) => {
        if (parentBinding.contains(b)) {
          const [childIndex] = b.relative(parentBinding);
          return typeof childIndex === "number" && childIndex > property;
        }
        return false;
      }).sort();
      bindingsToRewrite.forEach((trackedBinding) => {
        const [childIndex, ...childPath] = trackedBinding.relative(parentBinding);
        if (typeof childIndex === "number") {
          const newSegments = [childIndex - 1, ...childPath];
          const newChildBinding = parentBinding.descendent(newSegments);
          targetMap.set(newChildBinding, targetMap.get(trackedBinding));
          targetMap.delete(trackedBinding);
        }
      });
    }
    return targetMap;
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/validator/validation-middleware.ts
  var ValidationMiddleware = class {
    constructor(validator, options) {
      this.validator = validator;
      this.shadowModelPaths = /* @__PURE__ */ new Map();
      this.logger = options?.logger;
      this.shouldIncludeInvalid = options?.shouldIncludeInvalid;
    }
    set(transaction, options, next) {
      const asModel = toModel(this, { ...options, includeInvalid: true }, next);
      const nextTransaction = [];
      const includedBindings = /* @__PURE__ */ new Set();
      transaction.forEach(([binding, value]) => {
        this.shadowModelPaths.set(binding, value);
        includedBindings.add(binding);
      });
      const invalidBindings = [];
      this.shadowModelPaths.forEach((value, binding) => {
        const validations = this.validator(binding, asModel);
        if (validations === void 0) {
          nextTransaction.push([binding, value]);
        } else if (validations instanceof Set) {
          validations.forEach((validation) => {
            invalidBindings.push(validation.binding);
            if (!validation.isStrong && validation.binding.asString() === binding.asString()) {
              nextTransaction.push([validation.binding, value]);
            }
          });
        } else if (includedBindings.has(binding)) {
          invalidBindings.push(binding);
          this.logger?.debug(
            `Invalid value for path: ${binding.asString()} - ${validations.severity} - ${validations.message}`
          );
        }
      });
      let validResults = [];
      if (next && nextTransaction.length > 0) {
        nextTransaction.forEach(
          ([binding]) => this.shadowModelPaths.delete(binding)
        );
        const result = next.set(nextTransaction, options);
        if (invalidBindings.length === 0) {
          return result;
        }
        validResults = result;
      }
      const invalidResults = invalidBindings.map((binding) => {
        return {
          binding,
          oldValue: asModel.get(binding),
          newValue: asModel.get(binding),
          force: true
        };
      });
      return [...validResults, ...invalidResults];
    }
    get(binding, options, next) {
      let val = next?.get(binding, options);
      if (this.shouldIncludeInvalid?.(options) ?? options?.includeInvalid === true) {
        this.shadowModelPaths.forEach((shadowValue, shadowBinding) => {
          if (shadowBinding === binding) {
            val = shadowValue;
            return;
          }
          if (binding.contains(shadowBinding)) {
            val = (0, import_timm3.setIn)(val, shadowBinding.relative(binding), shadowValue);
          }
        });
      }
      return val;
    }
    delete(binding, options, next) {
      this.shadowModelPaths = removeBindingAndChildrenFromMap(
        this.shadowModelPaths,
        binding
      );
      return next?.delete(binding, options);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/validator/registry.ts
  var ValidatorRegistry = class {
    constructor() {
      this.registry = /* @__PURE__ */ new Map();
    }
    /** Use the given validator name to fetch the handler */
    get(name) {
      return this.registry.get(name);
    }
    /** Register a new validator */
    register(name, handler) {
      this.registry.set(name, handler);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/resolver/index.ts
  var import_timm5 = __toESM(require_timm());

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/dequal@2.0.3/node_modules/dequal/dist/index.mjs
  var has = Object.prototype.hasOwnProperty;
  function find(iter, tar, key) {
    for (key of iter.keys()) {
      if (dequal(key, tar))
        return key;
    }
  }
  function dequal(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar)
      return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
      if (ctor === Date)
        return foo.getTime() === bar.getTime();
      if (ctor === RegExp)
        return foo.toString() === bar.toString();
      if (ctor === Array) {
        if ((len = foo.length) === bar.length) {
          while (len-- && dequal(foo[len], bar[len]))
            ;
        }
        return len === -1;
      }
      if (ctor === Set) {
        if (foo.size !== bar.size) {
          return false;
        }
        for (len of foo) {
          tmp = len;
          if (tmp && typeof tmp === "object") {
            tmp = find(bar, tmp);
            if (!tmp)
              return false;
          }
          if (!bar.has(tmp))
            return false;
        }
        return true;
      }
      if (ctor === Map) {
        if (foo.size !== bar.size) {
          return false;
        }
        for (len of foo) {
          tmp = len[0];
          if (tmp && typeof tmp === "object") {
            tmp = find(bar, tmp);
            if (!tmp)
              return false;
          }
          if (!dequal(len[1], bar.get(tmp))) {
            return false;
          }
        }
        return true;
      }
      if (ctor === ArrayBuffer) {
        foo = new Uint8Array(foo);
        bar = new Uint8Array(bar);
      } else if (ctor === DataView) {
        if ((len = foo.byteLength) === bar.byteLength) {
          while (len-- && foo.getInt8(len) === bar.getInt8(len))
            ;
        }
        return len === -1;
      }
      if (ArrayBuffer.isView(foo)) {
        if ((len = foo.byteLength) === bar.byteLength) {
          while (len-- && foo[len] === bar[len])
            ;
        }
        return len === -1;
      }
      if (!ctor || typeof foo === "object") {
        len = 0;
        for (ctor in foo) {
          if (has.call(foo, ctor) && ++len && !has.call(bar, ctor))
            return false;
          if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor]))
            return false;
        }
        return Object.keys(bar).length === len;
      }
    }
    return foo !== foo && bar !== bar;
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/parser/index.ts
  var import_timm4 = __toESM(require_timm());

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/parser/types.ts
  var NodeType = /* @__PURE__ */ ((NodeType2) => {
    NodeType2["Asset"] = "asset";
    NodeType2["View"] = "view";
    NodeType2["Applicability"] = "applicability";
    NodeType2["Template"] = "template";
    NodeType2["Value"] = "value";
    NodeType2["MultiNode"] = "multi-node";
    NodeType2["Switch"] = "switch";
    NodeType2["Async"] = "async";
    NodeType2["Unknown"] = "unknown";
    NodeType2["Empty"] = "empty";
    return NodeType2;
  })(NodeType || {});

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/parser/utils.ts
  function hasTemplateValues(obj, localKey) {
    return Object.hasOwnProperty.call(obj, "template") && Array.isArray(obj?.template) && obj.template.length && obj.template.find((tmpl) => tmpl.output === localKey);
  }
  function hasSwitchKey(localKey) {
    return localKey === "staticSwitch" || localKey === "dynamicSwitch";
  }
  function hasTemplateKey(localKey) {
    return localKey === "template";
  }
  function getNodeID(node) {
    if (!node) {
      return;
    }
    if ("value" in node && typeof node.value === "object" && typeof node.value?.id === "string") {
      return node.value.id;
    }
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/parser/index.ts
  var EMPTY_NODE = {
    type: "empty" /* Empty */
  };
  var Parser = class {
    constructor() {
      this.hooks = {
        onParseObject: new SyncWaterfallHook(),
        onCreateASTNode: new SyncWaterfallHook(),
        parseNode: new SyncBailHook()
      };
    }
    parseView(value) {
      const viewNode = this.parseObject(value, "view" /* View */);
      if (!viewNode) {
        throw new Error("Unable to parse object into a view");
      }
      return viewNode;
    }
    createASTNode(node, value) {
      const tapped = this.hooks.onCreateASTNode.call(node, value);
      if (tapped === void 0) {
        return node;
      }
      return tapped;
    }
    parseObject(obj, type = "value" /* Value */, options = { templateDepth: 0 }) {
      const parsedNode = this.hooks.parseNode.call(
        obj,
        type,
        options
      );
      if (parsedNode || parsedNode === null) {
        return parsedNode;
      }
      const parseLocalObject = (currentValue, objToParse, path = []) => {
        if (typeof objToParse !== "object" || objToParse === null) {
          return { value: objToParse, children: [] };
        }
        const localObj = this.hooks.onParseObject.call(objToParse, type);
        if (!localObj) {
          return currentValue;
        }
        const objEntries = Array.isArray(localObj) ? localObj.map((v, i) => [i, v]) : [
          ...Object.entries(localObj),
          ...Object.getOwnPropertySymbols(localObj).map((s) => [
            s,
            localObj[s]
          ])
        ];
        const defaultValue = {
          children: [],
          value: currentValue
        };
        const newValue = objEntries.reduce((accumulation, current) => {
          let { value: value2 } = accumulation;
          const { children: children2 } = accumulation;
          const [localKey, localValue] = current;
          const newChildren = this.hooks.parseNode.call(
            localValue,
            "value" /* Value */,
            options,
            {
              path,
              key: localKey,
              parentObj: localObj
            }
          );
          if (newChildren) {
            children2.push(...newChildren);
          } else if (localValue && typeof localValue === "object") {
            const result = parseLocalObject(accumulation.value, localValue, [
              ...path,
              localKey
            ]);
            value2 = result.value;
            children2.push(...result.children);
          } else {
            value2 = (0, import_timm4.setIn)(accumulation.value, [...path, localKey], localValue);
          }
          return {
            value: value2,
            children: children2
          };
        }, defaultValue);
        return newValue;
      };
      const { value, children } = parseLocalObject(void 0, obj);
      const baseAst = value === void 0 && !children.length ? void 0 : {
        type,
        value
      };
      if (baseAst && children.length) {
        const parent = baseAst;
        parent.children = children;
        children.forEach((child) => {
          child.value.parent = parent;
        });
      }
      return this.hooks.onCreateASTNode.call(baseAst, obj) ?? null;
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/resolver/utils.ts
  function caresAboutDataChanges(dataChanges, dependencies) {
    if (!dataChanges || !dependencies) {
      return true;
    }
    const depArray = Array.from(dependencies.values());
    const dataChangeArray = Array.from(dataChanges.values());
    return depArray.find(
      (dep) => !!dataChangeArray.find(
        (change) => change === dep || change.contains(dep) || dep.contains(change)
      )
    ) !== void 0;
  }
  function toNodeResolveOptions(resolverOptions) {
    return {
      ...resolverOptions,
      data: {
        model: resolverOptions.model,
        formatValue: (ref, value) => {
          if (resolverOptions.formatValue) {
            return resolverOptions.formatValue(ref, value);
          }
          return value;
        },
        format: (bindingLike, value) => resolverOptions.format ? resolverOptions.format(
          isBinding(bindingLike) ? bindingLike : resolverOptions.parseBinding(bindingLike),
          value
        ) : value
      },
      evaluate: (exp) => resolverOptions.evaluator.evaluate(exp, resolverOptions)
    };
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/resolver/index.ts
  var withContext = (model) => {
    return {
      get: (binding, options) => {
        return model.get(binding, {
          context: { model },
          ...options
        });
      },
      set: (transaction, options) => {
        return model.set(transaction, {
          context: { model },
          ...options
        });
      },
      delete: (binding, options) => {
        return model.delete(binding, {
          context: { model },
          ...options
        });
      }
    };
  };
  var Resolver = class {
    constructor(root, options) {
      this.hooks = {
        skipResolve: new SyncWaterfallHook(),
        beforeUpdate: new SyncHook(),
        afterUpdate: new SyncHook(),
        resolveOptions: new SyncWaterfallHook(),
        beforeResolve: new SyncWaterfallHook(),
        resolve: new SyncWaterfallHook(),
        afterResolve: new SyncWaterfallHook(),
        afterNodeUpdate: new SyncHook()
      };
      this.root = root;
      this.options = options;
      this.resolveCache = /* @__PURE__ */ new Map();
      this.ASTMap = /* @__PURE__ */ new Map();
      this.logger = options.logger;
      this.idCache = /* @__PURE__ */ new Set();
    }
    getSourceNode(convertedAST) {
      return this.ASTMap.get(convertedAST);
    }
    update(dataChanges, nodeChanges) {
      this.hooks.beforeUpdate.call(dataChanges);
      const resolveCache = /* @__PURE__ */ new Map();
      this.idCache.clear();
      const prevASTMap = new Map(this.ASTMap);
      this.ASTMap.clear();
      const realNodeChanges = /* @__PURE__ */ new Set();
      for (const node of nodeChanges?.values() ?? []) {
        let current = node;
        while (current) {
          const original = prevASTMap.get(current) ?? current;
          if (realNodeChanges.has(original)) {
            break;
          }
          realNodeChanges.add(original);
          current = current.parent;
        }
      }
      const updated = this.computeTree(
        this.root,
        void 0,
        dataChanges,
        resolveCache,
        toNodeResolveOptions(this.options),
        void 0,
        prevASTMap,
        realNodeChanges
      );
      this.resolveCache = resolveCache;
      this.hooks.afterUpdate.call(updated.value);
      return updated.value;
    }
    getResolveCache() {
      return new Map(this.resolveCache);
    }
    getPreviousResult(node) {
      if (!node) {
        return;
      }
      const isFirstUpdate = this.resolveCache.size === 0;
      const id = getNodeID(node);
      if (id) {
        if (this.idCache.has(id)) {
          if (isFirstUpdate) {
            if (node.type === "asset" /* Asset */ || node.type === "view" /* View */) {
              this.logger?.error(
                `Cache conflict: Found Asset/View nodes that have conflicting ids: ${id}, may cause cache issues.`
              );
            } else if (node.type === "value" /* Value */) {
              this.logger?.info(
                `Cache conflict: Found Value nodes that have conflicting ids: ${id}, may cause cache issues. To improve performance make value node IDs globally unique.`
              );
            }
          }
          return;
        }
        this.idCache.add(id);
      }
      return this.resolveCache.get(node);
    }
    cloneNode(node) {
      const clonedNode = (0, import_timm5.clone)(node);
      Object.keys(clonedNode).forEach((key) => {
        if (key === "parent")
          return;
        const value = clonedNode[key];
        if (typeof value === "object" && value !== null) {
          clonedNode[key] = Array.isArray(value) ? [...value] : { ...value };
        }
      });
      return clonedNode;
    }
    computeTree(node, rawParent, dataChanges, cacheUpdate, options, partiallyResolvedParent, prevASTMap, nodeChanges) {
      const dependencyModel = new DependencyModel(options.data.model);
      dependencyModel.trackSubset("core");
      const depModelWithParser = withContext(
        withParser(dependencyModel, this.options.parseBinding)
      );
      const resolveOptions = this.hooks.resolveOptions.call(
        {
          ...options,
          data: {
            ...options.data,
            model: depModelWithParser
          },
          evaluate: (exp) => this.options.evaluator.evaluate(exp, { model: depModelWithParser }),
          node
        },
        node
      );
      const previousResult = this.getPreviousResult(node);
      const previousDeps = previousResult?.dependencies;
      const isChanged = nodeChanges.has(node);
      const dataChanged = caresAboutDataChanges(dataChanges, previousDeps);
      const shouldUseLastValue = this.hooks.skipResolve.call(
        !dataChanged && !isChanged,
        node,
        resolveOptions
      );
      if (previousResult && shouldUseLastValue) {
        const update2 = {
          ...previousResult,
          updated: false
        };
        const repopulateASTMapFromCache = (resolvedNode, AST, ASTParent) => {
          const { node: resolvedASTLocal } = resolvedNode;
          this.ASTMap.set(resolvedASTLocal, AST);
          const resolvedUpdate = {
            ...resolvedNode,
            updated: false
          };
          cacheUpdate.set(AST, resolvedUpdate);
          const handleChildNode = (childNode) => {
            const originalChildNode = prevASTMap.get(childNode) ?? childNode;
            const previousChildResult = this.getPreviousResult(originalChildNode);
            if (!previousChildResult)
              return;
            repopulateASTMapFromCache(
              previousChildResult,
              originalChildNode,
              AST
            );
          };
          if ("children" in resolvedASTLocal) {
            resolvedASTLocal.children?.forEach(
              ({ value: childAST }) => handleChildNode(childAST)
            );
          } else if (resolvedASTLocal.type === "multi-node" /* MultiNode */) {
            resolvedASTLocal.values.forEach(handleChildNode);
          }
          this.hooks.afterNodeUpdate.call(AST, ASTParent, resolvedUpdate);
        };
        previousResult.node.parent = partiallyResolvedParent;
        repopulateASTMapFromCache(previousResult, node, rawParent);
        return update2;
      }
      const clonedNode = {
        ...this.cloneNode(node),
        parent: partiallyResolvedParent
      };
      const resolvedAST = this.hooks.beforeResolve.call(
        clonedNode,
        resolveOptions
      ) ?? {
        type: "empty" /* Empty */
      };
      resolvedAST.parent = partiallyResolvedParent;
      resolveOptions.node = resolvedAST;
      this.ASTMap.set(resolvedAST, node);
      let resolved = this.hooks.resolve.call(
        void 0,
        resolvedAST,
        resolveOptions
      );
      let updated = !dequal(previousResult?.value, resolved);
      if (previousResult && !updated) {
        resolved = previousResult?.value;
      }
      const childDependencies = /* @__PURE__ */ new Set();
      dependencyModel.trackSubset("children");
      if ("children" in resolvedAST) {
        const newChildren = resolvedAST.children?.map((child) => {
          const computedChildTree = this.computeTree(
            child.value,
            node,
            dataChanges,
            cacheUpdate,
            resolveOptions,
            resolvedAST,
            prevASTMap,
            nodeChanges
          );
          const {
            dependencies: childTreeDeps,
            node: childNode,
            updated: childUpdated,
            value: childValue
          } = computedChildTree;
          childTreeDeps.forEach((binding) => childDependencies.add(binding));
          if (childValue) {
            if (childNode.type === "multi-node" /* MultiNode */ && !childNode.override) {
              const arr = (0, import_timm5.addLast)(
                dlv_es_default(resolved, child.path, []),
                childValue
              );
              resolved = (0, import_timm5.setIn)(resolved, child.path, arr);
            } else {
              resolved = (0, import_timm5.setIn)(resolved, child.path, childValue);
            }
          }
          updated = updated || childUpdated;
          return { ...child, value: childNode };
        });
        resolvedAST.children = newChildren;
      } else if (resolvedAST.type === "multi-node" /* MultiNode */) {
        const childValue = [];
        const rawParentToPassIn = node;
        resolvedAST.values = resolvedAST.values.map((mValue) => {
          const mTree = this.computeTree(
            mValue,
            rawParentToPassIn,
            dataChanges,
            cacheUpdate,
            resolveOptions,
            resolvedAST,
            prevASTMap,
            nodeChanges
          );
          if (mTree.value !== void 0 && mTree.value !== null) {
            mTree.dependencies.forEach(
              (bindingDep) => childDependencies.add(bindingDep)
            );
            updated = updated || mTree.updated;
            childValue.push(mTree.value);
          }
          return mTree.node;
        });
        resolved = childValue;
      }
      childDependencies.forEach(
        (bindingDep) => dependencyModel.addChildReadDep(bindingDep)
      );
      dependencyModel.trackSubset("core");
      if (previousResult && !updated) {
        resolved = previousResult?.value;
      }
      resolved = this.hooks.afterResolve.call(resolved, resolvedAST, {
        ...resolveOptions,
        getDependencies: (scope) => dependencyModel.getDependencies(scope)
      });
      const update = {
        node: resolvedAST,
        updated,
        value: resolved,
        dependencies: /* @__PURE__ */ new Set([
          ...dependencyModel.getDependencies(),
          ...childDependencies
        ])
      };
      this.hooks.afterNodeUpdate.call(node, rawParent, update);
      cacheUpdate.set(node, update);
      return update;
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/view.ts
  var CrossfieldProvider = class {
    constructor(initialView, parser, logger) {
      this.allValidations = /* @__PURE__ */ new Set();
      this.byBinding = /* @__PURE__ */ new Map();
      this.logger = logger;
      this.parse(initialView, parser);
    }
    parse(contentView, parser) {
      const xfieldRefs = contentView.validation;
      if (xfieldRefs === void 0) {
        return;
      }
      if (!Array.isArray(xfieldRefs)) {
        this.logger?.warn(
          `Unable to register view validations for id: ${contentView.id}. 'validation' property must be an Array.`
        );
        return;
      }
      xfieldRefs.forEach((vRef) => {
        const withDefaults = {
          trigger: "navigation",
          severity: "error",
          ...vRef
        };
        this.allValidations.add(withDefaults);
        const { ref } = vRef;
        if (ref) {
          const parsed = parser(ref);
          if (this.byBinding.has(parsed)) {
            this.byBinding.get(parsed)?.push(withDefaults);
          } else {
            this.byBinding.set(parsed, [withDefaults]);
          }
        }
      });
    }
    getValidationsForBinding(binding) {
      return this.byBinding.get(binding);
    }
  };
  var ViewInstance = class {
    constructor(initialView, resolverOptions) {
      this.hooks = {
        onUpdate: new SyncHook(),
        parser: new SyncHook(),
        resolver: new SyncHook(),
        templatePlugin: new SyncHook()
      };
      this.initialView = initialView;
      this.resolverOptions = resolverOptions;
    }
    /** @deprecated use ViewController.updateViewAST */
    updateAsync(asyncNode) {
      const update = this.resolver?.update();
      this.lastUpdate = update;
      this.hooks.onUpdate.call(update);
    }
    update(changes, nodeChanges) {
      if (this.rootNode === void 0) {
        this.validationProvider = new CrossfieldProvider(
          this.initialView,
          this.resolverOptions.parseBinding,
          this.resolverOptions.logger
        );
        if (this.templatePlugin) {
          this.hooks.templatePlugin.call(this.templatePlugin);
        } else {
          this.resolverOptions.logger?.warn(
            "templatePlugin not set for View, legacy templates may not work"
          );
        }
        const parser = new Parser();
        this.hooks.parser.call(parser);
        this.rootNode = parser.parseView(this.initialView);
        this.resolver = new Resolver(this.rootNode, {
          ...this.resolverOptions,
          parseNode: parser.parseObject.bind(parser)
        });
        this.hooks.resolver.call(this.resolver);
      }
      const update = this.resolver?.update(changes, nodeChanges);
      if (this.lastUpdate === update) {
        return this.lastUpdate;
      }
      this.lastUpdate = update;
      this.hooks.onUpdate.call(update);
      return update;
    }
    getValidationsForBinding(binding) {
      return this.validationProvider?.getValidationsForBinding(binding);
    }
    setTemplatePlugin(plugin) {
      this.templatePlugin = plugin;
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/builder/index.ts
  var Builder = class _Builder {
    /**
     * Creates an asset node
     *
     * @param value - the value to put in the asset node
     */
    static asset(value) {
      return {
        type: "asset" /* Asset */,
        value
      };
    }
    static assetWrapper(value) {
      const valueNode = _Builder.value();
      _Builder.addChild(valueNode, "asset", value);
      return valueNode;
    }
    /**
     * Creates a value node
     *
     * @param v - The object to put in the value node
     */
    static value(v) {
      return {
        type: "value" /* Value */,
        value: v
      };
    }
    /**
     * Creates a multiNode and associates the multiNode as the parent
     * of all the value nodes
     *
     * @param values - the value, applicability or async nodes to put in the multinode
     */
    static multiNode(...values) {
      const m = {
        type: "multi-node" /* MultiNode */,
        override: true,
        values
      };
      values.forEach((v) => {
        v.parent = m;
      });
      return m;
    }
    /**
     * Creates an async node
     *
     * @param id - the id of async node. It should be identical for each async node
     */
    static asyncNode(id, flatten2 = true, onValueReceived) {
      return {
        id,
        type: "async" /* Async */,
        flatten: flatten2,
        onValueReceived,
        value: {
          type: "value" /* Value */,
          value: {
            id
          }
        }
      };
    }
    /**
     * Adds a child node to a node
     *
     * @param node - The node to add a child to
     * @param path - The path at which to add the child
     * @param child - The child node
     */
    static addChild(node, path, child) {
      child.parent = node;
      const newChild = {
        path: Array.isArray(path) ? path : [path],
        value: child
      };
      node.children = node.children || [];
      node.children.push(newChild);
      return node;
    }
    /**
     * Updates children of a node of the same path and preserves order
     *
     * @param node - The node to update children for
     * @param pathToMatch - The path to match against child paths
     * @param mapFn - Function to transform matching children
     */
    static updateChildrenByPath(node, pathToMatch, updateFn) {
      if (!node.children)
        return node;
      const updatedChildren = node.children.map(
        (child) => (
          // Check if paths match exactly
          child.path.join() === pathToMatch.join() ? { ...child, value: updateFn(child) } : child
        )
      );
      return {
        ...node,
        children: updatedChildren
      };
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/plugins/template.ts
  var templateSymbol = Symbol("template");
  var TemplatePlugin = class {
    constructor(options) {
      this.hooks = {
        resolveTemplateSubstitutions: new SyncWaterfallHook()
      };
      this.options = options;
    }
    parseTemplate(parseObject, node, options) {
      const { template, depth } = node;
      const data = options.data.model.get(node.data);
      if (!data) {
        return null;
      }
      if (!Array.isArray(data)) {
        throw new Error(`Template using '${node.data}' but is not an array`);
      }
      const values = [];
      data.forEach((dataItem, index) => {
        const templateSubstitutions = this.hooks.resolveTemplateSubstitutions.call(
          [
            {
              expression: new RegExp(`_index${depth || ""}_`),
              value: String(index)
            }
          ],
          {
            depth,
            data: dataItem,
            index
          }
        );
        let templateStr = JSON.stringify(template);
        for (const { expression, value } of templateSubstitutions) {
          let flags = "g";
          if (typeof expression === "object") {
            flags = `${expression.flags}${expression.global ? "" : "g"}`;
          }
          templateStr = templateStr.replace(new RegExp(expression, flags), value);
        }
        const parsed = parseObject(JSON.parse(templateStr), "value" /* Value */, {
          templateDepth: node.depth + 1
        });
        if (parsed) {
          values.push(parsed);
        }
      });
      const result = {
        type: "multi-node" /* MultiNode */,
        override: false,
        values
      };
      if (node.placement !== void 0) {
        result[templateSymbol] = node.placement;
      }
      return result;
    }
    applyParser(parser) {
      parser.hooks.onCreateASTNode.tap("template", (node) => {
        if (node && node.type === "template" /* Template */ && !node.dynamic) {
          return this.parseTemplate(
            parser.parseObject.bind(parser),
            node,
            this.options
          );
        }
        return node;
      });
      parser.hooks.onCreateASTNode.tap("template", (node) => {
        function getTemplateSymbolValue(node2) {
          if (node2.type === "multi-node" /* MultiNode */) {
            return node2[templateSymbol];
          } else if (node2.type === "template" /* Template */) {
            return node2.placement;
          }
          return void 0;
        }
        if (node && (node.type === "view" /* View */ || node.type === "asset" /* Asset */) && Array.isArray(node.children)) {
          node.children = node.children.sort((a, b) => {
            const aPath = a.path.join();
            const bPath = b.path.join();
            const pathsEqual = aPath === bPath;
            if (pathsEqual) {
              const aPlacement = getTemplateSymbolValue(a.value);
              const bPlacement = getTemplateSymbolValue(b.value);
              if (aPlacement !== void 0 && bPlacement === void 0) {
                return aPlacement === "prepend" ? -1 : 1;
              } else if (bPlacement !== void 0 && aPlacement === void 0) {
                return bPlacement === "prepend" ? 1 : -1;
              } else if (aPlacement !== void 0 && bPlacement !== void 0) {
                if (aPlacement === bPlacement) {
                  return 0;
                }
                return aPlacement === "prepend" ? -1 : 1;
              }
              return 0;
            }
            return aPath > bPath ? 1 : -1;
          });
        }
        return node;
      });
      parser.hooks.parseNode.tap(
        "template",
        (obj, _nodeType, options, childOptions) => {
          if (childOptions && hasTemplateKey(childOptions.key)) {
            return obj.map((template) => {
              const templateAST = parser.createASTNode(
                {
                  type: "template" /* Template */,
                  depth: options.templateDepth ?? 0,
                  data: template.data,
                  template: template.value,
                  dynamic: template.dynamic ?? false,
                  placement: template.placement
                },
                template
              );
              if (!templateAST)
                return;
              if (templateAST.type === "multi-node" /* MultiNode */) {
                templateAST.values.forEach((v) => {
                  v.parent = templateAST;
                });
              }
              return {
                path: [...childOptions.path, template.output],
                value: templateAST
              };
            }).filter(Boolean);
          }
        }
      );
    }
    applyResolverHooks(resolver) {
      resolver.hooks.beforeResolve.tap("template", (node, options) => {
        if (node && node.type === "template" /* Template */ && node.dynamic) {
          return this.parseTemplate(options.parseNode, node, options);
        }
        return node;
      });
    }
    apply(view) {
      view.hooks.parser.tap("template", this.applyParser.bind(this));
      view.hooks.resolver.tap("template", this.applyResolverHooks.bind(this));
      view.setTemplatePlugin(this);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/plugins/string-resolver.ts
  var import_timm6 = __toESM(require_timm());
  var createPatternMatcher = (start, end) => {
    return (testStr) => {
      const startLocation = testStr.indexOf(start);
      if (startLocation === -1) {
        return false;
      }
      const endLocation = testStr.indexOf(end);
      if (endLocation === -1) {
        return false;
      }
      return startLocation < endLocation;
    };
  };
  var bindingResolveLookup = createPatternMatcher("{{", "}}");
  var expressionResolveLookup = createPatternMatcher("@[", "]@");
  function hasSomethingToResolve(str) {
    return bindingResolveLookup(str) || expressionResolveLookup(str);
  }
  function resolveString(str, resolveOptions) {
    return hasSomethingToResolve(str) ? resolveDataRefs(str, {
      model: resolveOptions.data.model,
      evaluate: resolveOptions.evaluate
    }) : str;
  }
  function resolveAllRefs(node, resolveOptions, propertiesToSkip) {
    if (node === null || node === void 0 || typeof node !== "object" && typeof node !== "string") {
      return node;
    }
    if (typeof node === "string") {
      return resolveString(node, resolveOptions);
    }
    let newNode = node;
    Object.keys(node).forEach((key) => {
      if (propertiesToSkip.has(key)) {
        return;
      }
      const val = node[key];
      let newVal = val;
      if (typeof val === "object") {
        newVal = resolveAllRefs(val, resolveOptions, propertiesToSkip);
      } else if (typeof val === "string") {
        newVal = resolveString(val, resolveOptions);
      }
      if (newVal !== val) {
        newNode = (0, import_timm6.set)(newNode, key, newVal);
      }
    });
    return newNode;
  }
  var findBasePath = (node, resolver) => {
    const parentNode = node.parent;
    if (!parentNode) {
      return [];
    }
    if ("children" in parentNode) {
      const original = resolver.getSourceNode(node);
      return parentNode.children?.find((child) => child.value === original)?.path ?? [];
    }
    if (parentNode.type !== "multi-node" /* MultiNode */) {
      return [];
    }
    return findBasePath(parentNode, resolver);
  };
  var StringResolverPlugin = class {
    constructor() {
      this.propertiesToSkipCache = /* @__PURE__ */ new Map();
    }
    applyResolver(resolver) {
      resolver.hooks.resolve.tap("string-resolver", (value, node, options) => {
        if (node.type === "empty" /* Empty */ || node.type === "unknown" /* Unknown */) {
          return null;
        }
        if (node.type === "value" /* Value */ || node.type === "asset" /* Asset */ || node.type === "view" /* View */) {
          let propsToSkip;
          if (node.type === "asset" /* Asset */ || node.type === "view" /* View */) {
            propsToSkip = new Set(
              node.plugins?.stringResolver?.propertiesToSkip ?? ["exp"]
            );
            if (node.value?.id) {
              this.propertiesToSkipCache.set(node.value.id, propsToSkip);
            }
          } else if (node.parent?.type === "multi-node" /* MultiNode */ && (node.parent?.parent?.type === "asset" /* Asset */ || node.parent?.parent?.type === "view" /* View */) && node.parent.parent.value?.id && this.propertiesToSkipCache.has(node.parent.parent.value.id)) {
            propsToSkip = this.propertiesToSkipCache.get(
              node.parent.parent.value.id
            );
          } else {
            propsToSkip = /* @__PURE__ */ new Set(["exp"]);
          }
          const nodePath = findBasePath(node, resolver);
          if (nodePath.length > 0 && nodePath.some((segment) => propsToSkip.has(segment.toString()))) {
            return node.value;
          }
          return resolveAllRefs(node.value, options, propsToSkip);
        }
        return value;
      });
    }
    apply(view) {
      view.hooks.resolver.tap("string-resolver", this.applyResolver.bind(this));
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/plugins/applicability.ts
  var import_timm7 = __toESM(require_timm());
  var ApplicabilityPlugin = class {
    isApplicability(obj) {
      return obj && Object.prototype.hasOwnProperty.call(obj, "applicability");
    }
    applyResolver(resolver) {
      resolver.hooks.beforeResolve.tap(
        "applicability",
        (node, options) => {
          let newNode = node;
          if (node?.type === "applicability" /* Applicability */) {
            const isApplicable = options.evaluate(node.expression);
            if (isApplicable === false) {
              return null;
            }
            newNode = node.value;
          }
          return newNode;
        }
      );
    }
    applyParser(parser) {
      parser.hooks.parseNode.tap(
        "applicability",
        (obj, nodeType, options, childOptions) => {
          if (this.isApplicability(obj)) {
            const parsedApplicability = parser.parseObject(
              (0, import_timm7.omit)(obj, "applicability"),
              nodeType,
              options
            );
            if (!parsedApplicability) {
              return childOptions ? [] : null;
            }
            const applicabilityNode = parser.createASTNode(
              {
                type: "applicability" /* Applicability */,
                expression: obj.applicability,
                value: parsedApplicability
              },
              obj
            );
            if (!applicabilityNode) {
              return childOptions ? [] : null;
            }
            if (applicabilityNode.type === "applicability" /* Applicability */) {
              applicabilityNode.value.parent = applicabilityNode;
            }
            return childOptions ? [
              {
                path: [...childOptions.path, childOptions.key],
                value: applicabilityNode
              }
            ] : applicabilityNode;
          }
        }
      );
    }
    apply(view) {
      view.hooks.resolver.tap("applicability", this.applyResolver.bind(this));
      view.hooks.parser.tap("applicability", this.applyParser.bind(this));
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/plugins/switch.ts
  var SwitchPlugin = class {
    constructor(options) {
      this.options = options;
    }
    resolveSwitch(node, options) {
      for (const switchCase of node.cases) {
        const isApplicable = options.evaluate(switchCase.case);
        if (isApplicable) {
          return switchCase.value;
        }
      }
      return EMPTY_NODE;
    }
    isSwitch(obj) {
      return obj && (Object.prototype.hasOwnProperty.call(obj, "dynamicSwitch") || Object.prototype.hasOwnProperty.call(obj, "staticSwitch"));
    }
    applyParser(parser) {
      parser.hooks.onCreateASTNode.tap("switch", (node) => {
        if (node && node.type === "switch" /* Switch */ && !node.dynamic) {
          return this.resolveSwitch(node, this.options);
        }
        return node;
      });
      parser.hooks.parseNode.tap(
        "switch",
        (obj, _nodeType, options, childOptions) => {
          if (this.isSwitch(obj) || childOptions && hasSwitchKey(childOptions.key)) {
            const objToParse = childOptions && hasSwitchKey(childOptions.key) ? { [childOptions.key]: obj } : obj;
            const dynamic = "dynamicSwitch" in objToParse;
            const switchContent = dynamic ? objToParse.dynamicSwitch : objToParse.staticSwitch;
            const cases = switchContent.map(
              (switchCase) => {
                const { case: switchCaseExpr, ...switchBody } = switchCase;
                const value = parser.parseObject(
                  switchBody,
                  "value" /* Value */,
                  options
                );
                if (value) {
                  return {
                    case: switchCaseExpr,
                    value
                  };
                }
                return;
              }
            ).filter(Boolean);
            const switchAST = parser.createASTNode(
              {
                type: "switch" /* Switch */,
                dynamic,
                cases
              },
              objToParse
            );
            if (!switchAST || switchAST.type === "empty" /* Empty */) {
              return childOptions ? [] : null;
            }
            if (switchAST.type === "switch" /* Switch */) {
              switchAST.cases.forEach((sCase) => {
                sCase.value.parent = switchAST;
              });
            }
            if (childOptions) {
              let path = [...childOptions.path, childOptions.key];
              let value = switchAST;
              if (switchAST.type === "value" /* Value */ && switchAST.children?.length === 1 && switchAST.value === void 0) {
                const firstChild = switchAST.children[0];
                path = [...path, ...firstChild.path];
                value = firstChild.value;
              }
              return [{ path, value }];
            }
            return switchAST;
          }
        }
      );
    }
    applyResolver(resolver) {
      resolver.hooks.beforeResolve.tap("switch", (node, options) => {
        if (node && node.type === "switch" /* Switch */ && node.dynamic) {
          return this.resolveSwitch(node, options);
        }
        return node;
      });
    }
    apply(view) {
      view.hooks.parser.tap("switch", this.applyParser.bind(this));
      view.hooks.resolver.tap("switch", this.applyResolver.bind(this));
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/plugins/multi-node.ts
  var MultiNodePlugin = class {
    applyParser(parser) {
      parser.hooks.parseNode.tap(
        "multi-node",
        (obj, nodeType, options, childOptions) => {
          if ((childOptions === void 0 || !hasTemplateKey(childOptions.key)) && Array.isArray(obj)) {
            const values = obj.map(
              (childVal) => parser.parseObject(childVal, "value" /* Value */, options)
            ).filter((child) => !!child);
            if (!values.length) {
              return [];
            }
            const multiNode = parser.createASTNode(
              {
                type: "multi-node" /* MultiNode */,
                override: childOptions !== void 0 && !hasTemplateValues(childOptions.parentObj, childOptions.key),
                values
              },
              obj
            );
            if (!multiNode) {
              return [];
            }
            if (multiNode.type === "multi-node" /* MultiNode */) {
              multiNode.values.forEach((v) => {
                v.parent = multiNode;
              });
            }
            return childOptions === void 0 ? multiNode : [
              {
                path: [...childOptions.path, childOptions.key],
                value: multiNode
              }
            ];
          }
        }
      );
    }
    apply(view) {
      view.hooks.parser.tap("multi-node", this.applyParser.bind(this));
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/plugins/asset.ts
  var AssetPlugin = class {
    applyParser(parser) {
      parser.hooks.parseNode.tap(
        "asset",
        (obj, nodeType, options, childOptions) => {
          if (childOptions?.key === "asset" && typeof obj === "object") {
            const assetAST = parser.parseObject(obj, "asset" /* Asset */, options);
            if (!assetAST) {
              return [];
            }
            return [
              {
                path: [...childOptions.path, childOptions.key],
                value: assetAST
              }
            ];
          }
        }
      );
    }
    apply(view) {
      view.hooks.parser.tap("asset", this.applyParser.bind(this));
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/view/store.ts
  var LocalStateStore = class {
    constructor(onUpdate) {
      this.updateCallback = onUpdate;
      this.state = /* @__PURE__ */ new Map();
    }
    removeKey(key) {
      this.state.delete(key);
    }
    reset() {
      this.state.clear();
    }
    useSharedState(key) {
      return (initialState) => {
        if (!this.state.has(key)) {
          this.state.set(key, initialState);
        }
        return [
          this.state.get(key),
          (newState) => {
            const current = this.state.get(key);
            this.state.set(key, newState);
            if (current !== newState) {
              this.updateCallback?.();
            }
          }
        ];
      };
    }
    getLocalStateFunction(key, countKey) {
      return (initialState) => {
        if (!this.state.has(key)) {
          this.state.set(key, []);
        }
        if (!this.state.has(countKey)) {
          this.state.set(countKey, 0);
        }
        const localState = this.state.get(key);
        const oldCount = this.state.get(countKey);
        this.state.set(countKey, oldCount + 1);
        if (localState.length <= oldCount) {
          localState.push(initialState);
        }
        const value = localState[oldCount];
        return [
          value,
          (newState) => {
            const oldValue = localState[oldCount];
            localState[oldCount] = newState;
            if (oldValue !== newState) {
              this.updateCallback?.();
            }
          }
        ];
      };
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/view/plugins/asset-transform.ts
  function findUp(node, target) {
    if (node === target) {
      return true;
    }
    if (node.parent) {
      return findUp(node.parent, target);
    }
    return false;
  }
  var AssetTransformCorePlugin = class {
    constructor(registry) {
      this.registry = registry;
      this.stateStore = /* @__PURE__ */ new Map();
      this.beforeResolveSymbol = Symbol("before resolve");
      this.resolveSymbol = Symbol("resolve");
      this.beforeResolveCountSymbol = Symbol("before resolve count");
      this.resolveCountSymbol = Symbol("resolve count");
    }
    apply(view) {
      this.stateStore.clear();
      view.hooks.resolver.tap("asset-transform", (resolver) => {
        let lastUpdatedNode;
        const updateState = (node) => {
          lastUpdatedNode = node;
          view.update(/* @__PURE__ */ new Set());
        };
        const getStore = (node, stepKey) => {
          let store;
          const countKey = stepKey === this.resolveSymbol ? this.resolveCountSymbol : this.beforeResolveCountSymbol;
          const storedState = this.stateStore.get(node);
          if (storedState) {
            store = storedState;
            store.removeKey(countKey);
          } else {
            store = new LocalStateStore(() => {
              updateState(node);
            });
            this.stateStore.set(node, store);
          }
          return {
            useSharedState: (key) => {
              return store.useSharedState(key);
            },
            useLocalState: (initialState) => {
              return store.getLocalStateFunction(
                stepKey,
                countKey
              )(initialState);
            }
          };
        };
        resolver.hooks.beforeResolve.tap("asset-transform", (node, options) => {
          if (node && (node.type === "asset" || node.type === "view")) {
            const transform = this.registry.get(node.value);
            if (transform?.beforeResolve) {
              const store = getStore(
                options.node ?? node,
                this.beforeResolveSymbol
              );
              return transform.beforeResolve(node, options, store);
            }
          }
          return node;
        });
        resolver.hooks.afterUpdate.tap("asset-transform", () => {
          lastUpdatedNode = void 0;
        });
        resolver.hooks.skipResolve.tap("asset-transform", (skip, node) => {
          if (!skip || !lastUpdatedNode) {
            return skip;
          }
          const isParentOfUpdated = findUp(lastUpdatedNode, node);
          const isChildOfUpdated = findUp(node, lastUpdatedNode);
          return !isParentOfUpdated && !isChildOfUpdated;
        });
        resolver.hooks.afterResolve.tap(
          "asset-transform",
          (value, node, options) => {
            if (node.type !== "asset" /* Asset */ && node.type !== "view" /* View */) {
              return value;
            }
            const originalNode = resolver.getSourceNode(node);
            if (!originalNode) {
              return value;
            }
            const transform = this.registry.get(value);
            if (transform?.resolve) {
              const store = getStore(originalNode, this.resolveSymbol);
              return transform?.resolve(value, options, store);
            }
            return value;
          }
        );
      });
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/player.ts
  var import_timm9 = __toESM(require_timm());
  var import_p_defer2 = __toESM(require_p_defer());
  var import_queue_microtask2 = __toESM(require_queue_microtask());

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/flow/flow.ts
  var import_p_defer = __toESM(require_p_defer());
  var FlowInstance = class {
    constructor(id, flow, options) {
      this.isTransitioning = false;
      this.hooks = {
        beforeStart: new SyncBailHook(),
        onStart: new SyncHook(),
        onEnd: new SyncHook(),
        skipTransition: new SyncBailHook(),
        beforeTransition: new SyncWaterfallHook(),
        resolveTransitionNode: new SyncWaterfallHook(),
        transition: new SyncHook(),
        afterTransition: new SyncHook()
      };
      this.id = id;
      this.flow = flow;
      this.log = options?.logger;
      this.history = [];
      this.hooks.transition.tap(
        "startPromise",
        async (_oldState, nextState) => {
          const newState = nextState.value;
          if (this.flowPromise && newState.state_type === "END") {
            this.flowPromise.resolve(newState);
          }
        }
      );
    }
    /** Start the state machine */
    async start() {
      if (this.flowPromise) {
        this.log?.warn("Already called start for flow");
        return this.flowPromise.promise;
      }
      this.flow = this.hooks.beforeStart.call(this.flow) || this.flow;
      if (this.flow.onStart) {
        this.hooks.onStart.call(this.flow.onStart);
      }
      const initialState = this.flow.startState;
      if (!initialState) {
        return Promise.reject(new Error("No 'startState' defined for flow"));
      }
      this.flowPromise = (0, import_p_defer.default)();
      this.pushHistory(initialState);
      return this.flowPromise.promise;
    }
    transition(transitionValue, options) {
      if (this.isTransitioning) {
        throw new Error(
          `Transitioning while ongoing transition from ${this.currentState?.name} is in progress is not supported`
        );
      }
      if (this.currentState?.value.state_type === "END") {
        this.log?.warn(
          `Skipping transition using ${transitionValue}. Already at and END state`
        );
        return;
      }
      if (this.currentState === void 0) {
        throw new Error("Cannot transition when there's no current state");
      }
      if (options?.force) {
        this.log?.debug(`Forced transition. Skipping validation checks`);
      } else {
        const skipTransition = this.hooks.skipTransition.call(this.currentState);
        if (skipTransition) {
          this.log?.debug(
            `Skipping transition from ${this.currentState.name} b/c hook told us to`
          );
          return;
        }
      }
      const state = this.hooks.beforeTransition.call(
        this.currentState.value,
        transitionValue
      );
      if (!("transitions" in state)) {
        throw new Error(`No transitions defined for ${this.currentState.value}`);
      }
      const { transitions } = state;
      const nextState = transitions[transitionValue] || transitions["*"];
      if (nextState === void 0) {
        this.log?.warn(
          `No transition from ${this.currentState.name} using ${transitionValue} or *`
        );
        return;
      }
      this.log?.debug(
        `Transitioning from ${this.currentState.name} to ${nextState} using ${transitionValue} `
      );
      return this.pushHistory(nextState, options);
    }
    pushHistory(stateName, options) {
      if (!Object.prototype.hasOwnProperty.call(this.flow, stateName)) {
        throw new Error(`No flow definition for: ${stateName} was found.`);
      }
      let nextState = this.flow[stateName];
      if (!this.flow[stateName] || typeof nextState !== "object" || !("state_type" in nextState)) {
        this.log?.error(`Flow doesn't contain any states named: ${stateName}`);
        return;
      }
      const prevState = this.currentState;
      this.isTransitioning = true;
      nextState = this.hooks.resolveTransitionNode.call(nextState);
      const newCurrentState = {
        name: stateName,
        value: nextState
      };
      this.currentState = newCurrentState;
      this.history.push(stateName);
      if (newCurrentState.value.state_type === "END" && this.flow.onEnd) {
        this.hooks.onEnd.call(this.flow.onEnd);
      }
      this.hooks.transition.call(prevState, {
        ...newCurrentState
      });
      this.isTransitioning = false;
      this.hooks.afterTransition.call(this);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/flow/controller.ts
  var FlowController = class {
    constructor(navigation, options) {
      this.hooks = {
        flow: new SyncHook()
      };
      this.navigation = navigation;
      this.navStack = [];
      this.log = options?.logger;
      this.start = this.start.bind(this);
      this.run = this.run.bind(this);
      this.transition = this.transition.bind(this);
      this.addNewFlow = this.addNewFlow.bind(this);
    }
    /** Navigate to another state in the state-machine */
    transition(stateTransition, options) {
      if (this.current === void 0) {
        throw new Error("Not currently in a flow. Cannot transition.");
      }
      this.current.transition(stateTransition, options);
    }
    addNewFlow(flow) {
      this.navStack.push(flow);
      this.current = flow;
      this.hooks.flow.call(flow);
    }
    async run(startState) {
      if (!Object.prototype.hasOwnProperty.call(this.navigation, startState)) {
        return Promise.reject(new Error(`No flow defined for: ${startState}`));
      }
      const startFlow = this.navigation[startState];
      if (startFlow === null || typeof startFlow !== "object") {
        return Promise.reject(
          new Error(`Flow: ${startState} needs to be an object`)
        );
      }
      this.log?.debug(`Starting flow: ${startState}`);
      const flow = new FlowInstance(startState, startFlow, { logger: this.log });
      this.addNewFlow(flow);
      flow.hooks.afterTransition.tap("flow-controller", (flowInstance) => {
        if (flowInstance.currentState?.value.state_type === "FLOW") {
          const subflowId = flowInstance.currentState?.value.ref;
          this.log?.debug(`Loading subflow ${subflowId}`);
          this.run(subflowId).then((subFlowEndState) => {
            this.log?.debug(
              `Subflow ended. Using outcome: ${subFlowEndState.outcome}`
            );
            flowInstance.transition(subFlowEndState?.outcome);
          });
        }
      });
      const end = await flow.start();
      this.navStack.pop();
      if (this.navStack.length > 0) {
        const firstItem = 0;
        this.current = this.navStack[firstItem];
      }
      return end;
    }
    async start() {
      if (!this.navigation.BEGIN) {
        return Promise.reject(new Error("Must supply a BEGIN state"));
      }
      return this.run(this.navigation.BEGIN);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/validation/controller.ts
  var import_timm8 = __toESM(require_timm());

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/utils/replaceParams.ts
  var ANY_CHAR_REGEX = /%([a-zA-Z]+)/g;
  function replaceParams(message, params) {
    return message.slice().replace(ANY_CHAR_REGEX, (keyExpr) => params[keyExpr.slice(1)] || keyExpr);
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/validation/binding-tracker.ts
  var CONTEXT = "validation-binding-tracker";
  var ValidationBindingTrackerViewPlugin = class {
    constructor(options) {
      this.trackedBindings = /* @__PURE__ */ new Set();
      this.options = options;
    }
    /** Fetch the tracked bindings in the current view */
    getBindings() {
      return this.trackedBindings;
    }
    /** Add a binding to the tracked set */
    trackBinding(binding) {
      if (this.trackedBindings.has(binding)) {
        return;
      }
      this.trackedBindings.add(binding);
      this.options.callbacks?.onAdd?.(binding);
    }
    /** Attach hooks to the given resolver */
    applyResolver(resolver) {
      this.trackedBindings.clear();
      const tracked = /* @__PURE__ */ new Map();
      const sections = /* @__PURE__ */ new Map();
      let lastViewUpdateChangeSet;
      const lastComputedBindingTree = /* @__PURE__ */ new Map();
      let currentBindingTree = /* @__PURE__ */ new Map();
      const lastSectionBindingTree = /* @__PURE__ */ new Map();
      const resolvedNodeMap = /* @__PURE__ */ new Map();
      resolver.hooks.beforeUpdate.tap(CONTEXT, (changes) => {
        lastViewUpdateChangeSet = changes;
      });
      resolver.hooks.skipResolve.tap(CONTEXT, (shouldSkip, node) => {
        const trackedBindingsForNode = lastComputedBindingTree.get(node);
        if (!shouldSkip || !lastViewUpdateChangeSet || !trackedBindingsForNode) {
          return shouldSkip;
        }
        const intersection = new Set(
          [...lastViewUpdateChangeSet].filter(
            (b) => trackedBindingsForNode.has(b)
          )
        );
        return intersection.size === 0;
      });
      resolver.hooks.resolveOptions.tap(CONTEXT, (options, node) => {
        if (options.validation === void 0) {
          return options;
        }
        tracked.delete(node);
        const track = (binding) => {
          const parsed = isBinding(binding) ? binding : this.options.parseBinding(binding);
          if (tracked.has(node)) {
            tracked.get(node)?.add(parsed);
          } else {
            tracked.set(node, /* @__PURE__ */ new Set([parsed]));
          }
          let { parent } = node;
          while (parent) {
            if (sections.has(parent)) {
              sections.get(parent)?.add(node);
              break;
            } else {
              parent = parent.parent;
            }
          }
          this.trackedBindings.add(parsed);
          this.options.callbacks?.onAdd?.(parsed);
        };
        return {
          ...options,
          validation: {
            ...options.validation,
            get: (binding, getOptions) => {
              if (getOptions?.track) {
                track(binding);
              }
              const eows = options.validation?._getValidationForBinding(binding)?.getAll(getOptions);
              const firstFieldEOW = eows?.find(
                (eow) => eow.displayTarget === "field" || eow.displayTarget === void 0
              );
              return firstFieldEOW;
            },
            getValidationsForBinding(binding, getOptions) {
              if (getOptions?.track) {
                track(binding);
              }
              return options.validation?._getValidationForBinding(binding)?.getAll(getOptions) ?? [];
            },
            getChildren: (type) => {
              const validations = new Array();
              lastComputedBindingTree.get(node)?.forEach((binding) => {
                const eow = options.validation?._getValidationForBinding(binding)?.get();
                if (eow && (type === void 0 || type === eow.displayTarget)) {
                  validations.push(eow);
                }
              });
              return validations;
            },
            getValidationsForSection: () => {
              const validations = new Array();
              lastSectionBindingTree.get(node)?.forEach((binding) => {
                const eow = options.validation?._getValidationForBinding(binding)?.get();
                if (eow && eow.displayTarget === "section") {
                  validations.push(eow);
                }
              });
              return validations;
            },
            register: (registerOptions) => {
              if (registerOptions?.type === "section") {
                if (!sections.has(node)) {
                  sections.set(node, /* @__PURE__ */ new Set());
                }
              }
            },
            track
          }
        };
      });
      resolver.hooks.afterNodeUpdate.tap(
        CONTEXT,
        (originalNode, parent, update) => {
          const { updated, node: resolvedNode } = update;
          resolvedNodeMap.set(resolvedNode, originalNode);
          if (updated) {
            const newlyComputed = new Set(tracked.get(originalNode));
            if (resolvedNode.type === "multi-node" /* MultiNode */) {
              resolvedNode.values.forEach(
                (value) => currentBindingTree.get(value)?.forEach((b) => newlyComputed.add(b))
              );
            }
            if ("children" in resolvedNode && resolvedNode.children) {
              resolvedNode.children.forEach((child) => {
                currentBindingTree.get(child.value)?.forEach((b) => newlyComputed.add(b));
              });
            }
            currentBindingTree.set(resolvedNode, newlyComputed);
          } else {
            currentBindingTree.set(
              resolvedNode,
              lastComputedBindingTree.get(originalNode) ?? /* @__PURE__ */ new Set()
            );
          }
          if (originalNode === resolver.root) {
            this.trackedBindings = new Set(currentBindingTree.get(resolvedNode));
            lastComputedBindingTree.clear();
            currentBindingTree.forEach((value, key) => {
              const node = resolvedNodeMap.get(key);
              if (node) {
                lastComputedBindingTree.set(node, value);
              }
            });
            lastSectionBindingTree.clear();
            sections.forEach((nodeSet, sectionNode) => {
              const temp = /* @__PURE__ */ new Set();
              nodeSet.forEach((n) => {
                tracked.get(n)?.forEach(temp.add, temp);
              });
              lastSectionBindingTree.set(sectionNode, temp);
            });
            tracked.clear();
            sections.clear();
            currentBindingTree = /* @__PURE__ */ new Map();
          }
        }
      );
    }
    apply(view) {
      view.hooks.resolver.tap(CONTEXT, this.applyResolver.bind(this));
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/validation/controller.ts
  var SCHEMA_VALIDATION_PROVIDER_NAME = "schema";
  var VIEW_VALIDATION_PROVIDER_NAME = "view";
  var VALIDATION_PROVIDER_NAME_SYMBOL = Symbol.for(
    "validation-provider-name"
  );
  function isSubset(subset, containingSet) {
    if (subset.size > containingSet.size)
      return false;
    for (const entry of subset)
      if (!containingSet.has(entry))
        return false;
    return true;
  }
  function createStatefulValidationObject(obj) {
    return {
      value: obj,
      type: obj.severity,
      state: "none",
      isBlockingNavigation: false
    };
  }
  var ValidatedBinding = class {
    constructor(possibleValidations, onDismiss, log, weakBindings) {
      this.applicableValidations = [];
      this.validationsByState = {
        load: [],
        change: [],
        navigation: []
      };
      this.onDismiss = onDismiss;
      possibleValidations.forEach((vObj) => {
        const { trigger } = vObj;
        if (this.validationsByState[trigger]) {
          const statefulValidationObject = createStatefulValidationObject(vObj);
          this.validationsByState[trigger].push(statefulValidationObject);
        } else {
          log?.warn(`Unknown validation trigger: ${trigger}`);
        }
      });
      this.weakBindings = weakBindings ?? /* @__PURE__ */ new Set();
    }
    get allValidations() {
      return Object.values(this.validationsByState).flat();
    }
    checkIfBlocking(statefulObj) {
      if (statefulObj.state === "active") {
        const { isBlockingNavigation } = statefulObj;
        return isBlockingNavigation;
      }
      return false;
    }
    getAll() {
      return this.applicableValidations.reduce((all, statefulObj) => {
        if (statefulObj.state === "active" && statefulObj.response) {
          all.push({
            ...statefulObj.response,
            blocking: this.checkIfBlocking(statefulObj)
          });
        }
        return all;
      }, []);
    }
    get() {
      const firstInvalid = this.applicableValidations.find((statefulObj) => {
        return statefulObj.state === "active" && statefulObj.response;
      });
      if (firstInvalid?.state === "active") {
        return {
          ...firstInvalid.response,
          blocking: this.checkIfBlocking(firstInvalid)
        };
      }
    }
    runApplicableValidations(runner, canDismiss, phase) {
      this.applicableValidations = this.applicableValidations.map(
        (originalValue) => {
          if (originalValue.state === "dismissed") {
            return originalValue;
          }
          const blocking = originalValue.value.blocking ?? (originalValue.value.severity === "warning" && "once" || true);
          const obj = (0, import_timm8.setIn)(
            originalValue,
            ["value", "blocking"],
            blocking
          );
          const isBlockingNavigation = blocking === true || blocking === "once" && !canDismiss;
          if (phase === "navigation" && obj.state === "active" && obj.value.blocking !== true) {
            if (obj.value.severity === "warning") {
              const warn = obj;
              if (warn.dismissable && warn.response.dismiss && (warn.response.blocking !== "once" || !warn.response.blocking)) {
                warn.response.dismiss();
              } else {
                if (warn?.response.blocking === "once") {
                  warn.response.blocking = false;
                }
                warn.dismissable = true;
              }
              return warn;
            }
          }
          const response = runner(obj.value);
          const newState = {
            type: obj.type,
            value: obj.value,
            state: response ? "active" : "none",
            isBlockingNavigation,
            dismissable: obj.value.severity === "warning" && phase === "navigation",
            response: response ? {
              ...obj.value,
              message: response.message ?? "Something is broken",
              severity: obj.value.severity,
              displayTarget: obj.value.displayTarget ?? "field"
            } : void 0
          };
          if (newState.state === "active" && obj.value.severity === "warning") {
            newState.response.dismiss = () => {
              newState.state = "dismissed";
              this.onDismiss?.();
            };
          }
          return newState;
        }
      );
    }
    update(phase, canDismiss, runner) {
      const newApplicableValidations = [];
      if (phase === "load" && this.currentPhase !== void 0) {
        return;
      }
      if (this.currentPhase === "navigation" || phase === this.currentPhase) {
        this.runApplicableValidations(runner, canDismiss, phase);
        return;
      }
      if (phase === "load") {
        this.currentPhase = "load";
        this.applicableValidations = [...this.validationsByState.load];
      } else if (phase === "change" && this.currentPhase === "load") {
        this.currentPhase = "change";
        this.applicableValidations = [
          ...this.applicableValidations,
          ...this.validationsByState.change
        ];
      } else if (phase === "navigation" && (this.currentPhase === "load" || this.currentPhase === "change")) {
        this.applicableValidations.forEach((element) => {
          if (!(element.type === "error" && element.state === "active" && element.isBlockingNavigation === false)) {
            newApplicableValidations.push(element);
          }
        });
        this.applicableValidations = [
          ...newApplicableValidations,
          ...this.validationsByState.navigation,
          ...this.currentPhase === "load" ? this.validationsByState.change : []
        ];
        this.currentPhase = "navigation";
      }
      this.runApplicableValidations(runner, canDismiss, phase);
    }
  };
  var ValidationController = class {
    constructor(schema, options) {
      this.hooks = {
        /** A hook called to tap into the validator registry for adding more validators */
        createValidatorRegistry: new SyncHook(),
        /** A callback/event when a new validation is added to the view */
        onAddValidation: new SyncWaterfallHook(),
        /** The inverse of onAddValidation, this is called when a validation is removed from the list */
        onRemoveValidation: new SyncWaterfallHook(),
        resolveValidationProviders: new SyncWaterfallHook(),
        /** A hook called when a binding is added to the tracker */
        onTrackBinding: new SyncHook()
      };
      this.validations = /* @__PURE__ */ new Map();
      this.weakBindingTracker = /* @__PURE__ */ new Set();
      this.schema = schema;
      this.options = options;
      this.reset();
    }
    setOptions(options) {
      this.options = options;
    }
    /** Return the middleware for the data-model to stop propagation of invalid data */
    getDataMiddleware() {
      return [
        {
          set: (transaction, options, next) => {
            return next?.set(transaction, options) ?? [];
          },
          get: (binding, options, next) => {
            return next?.get(binding, options);
          },
          delete: (binding, options, next) => {
            this.validations = removeBindingAndChildrenFromMap(
              this.validations,
              binding
            );
            return next?.delete(binding, options);
          }
        },
        new ValidationMiddleware(
          (binding) => {
            if (!this.options) {
              return;
            }
            this.updateValidationsForBinding(binding, "change", this.options);
            const strongValidation = this.getValidationForBinding(binding);
            if (strongValidation?.get()?.severity === "error") {
              return strongValidation.get();
            }
            const newInvalidBindings = /* @__PURE__ */ new Set();
            this.validations.forEach((weakValidation, strongBinding) => {
              if (caresAboutDataChanges(
                /* @__PURE__ */ new Set([binding]),
                weakValidation.weakBindings
              ) && weakValidation?.get()?.severity === "error") {
                weakValidation?.weakBindings.forEach((weakBinding) => {
                  if (weakBinding === strongBinding) {
                    newInvalidBindings.add({
                      binding: weakBinding,
                      isStrong: true
                    });
                  } else {
                    newInvalidBindings.add({
                      binding: weakBinding,
                      isStrong: false
                    });
                  }
                });
              }
            });
            if (newInvalidBindings.size > 0) {
              return newInvalidBindings;
            }
          },
          { logger: new ProxyLogger(() => this.options?.logger) }
        )
      ];
    }
    getValidationProviders() {
      if (this.providers) {
        return this.providers;
      }
      this.providers = this.hooks.resolveValidationProviders.call([
        {
          source: SCHEMA_VALIDATION_PROVIDER_NAME,
          provider: this.schema
        },
        {
          source: VIEW_VALIDATION_PROVIDER_NAME,
          provider: {
            getValidationsForBinding: (binding) => {
              return this.viewValidationProvider?.getValidationsForBinding?.(
                binding
              );
            },
            getValidationsForView: () => {
              return this.viewValidationProvider?.getValidationsForView?.();
            }
          }
        }
      ]);
      return this.providers;
    }
    reset() {
      this.validations.clear();
      this.tracker = void 0;
    }
    onView(view) {
      this.validations.clear();
      if (!this.options) {
        return;
      }
      const bindingTrackerPlugin = new ValidationBindingTrackerViewPlugin({
        ...this.options,
        callbacks: {
          onAdd: (binding) => {
            if (!this.options || this.getValidationForBinding(binding) !== void 0) {
              return;
            }
            const originalValue = this.options.model.get(binding);
            const withoutDefault = this.options.model.get(binding, {
              ignoreDefaultValue: true
            });
            if (originalValue !== withoutDefault) {
              this.options.model.set([[binding, originalValue]], {
                silent: true
              });
            }
            this.updateValidationsForBinding(
              binding,
              "load",
              this.options,
              () => {
                view.update(/* @__PURE__ */ new Set([binding]));
              }
            );
            this.hooks.onTrackBinding.call(binding);
          }
        }
      });
      this.tracker = bindingTrackerPlugin;
      this.viewValidationProvider = view;
      bindingTrackerPlugin.apply(view);
    }
    updateValidationsForBinding(binding, trigger, validationContext, onDismiss) {
      const context = validationContext ?? this.options;
      if (!context) {
        throw new Error(`Context is required for executing validations`);
      }
      if (trigger === "load") {
        const possibleValidations = this.getValidationProviders().reduce((vals, provider) => {
          vals.push(
            ...provider.provider.getValidationsForBinding?.(binding)?.map((valObj) => ({
              ...valObj,
              [VALIDATION_PROVIDER_NAME_SYMBOL]: provider.source
            })) ?? []
          );
          return vals;
        }, []);
        if (possibleValidations.length === 0) {
          return;
        }
        this.validations.set(
          binding,
          new ValidatedBinding(
            possibleValidations,
            onDismiss,
            this.options?.logger
          )
        );
      }
      const trackedValidations = this.validations.get(binding);
      trackedValidations?.update(trigger, true, (validationObj) => {
        const response = this.validationRunner(validationObj, binding, context);
        if (this.weakBindingTracker.size > 0) {
          const t2 = this.validations.get(binding);
          this.weakBindingTracker.forEach((b) => t2.weakBindings.add(b));
        }
        return response ? { message: response.message } : void 0;
      });
      if (trigger !== "load") {
        this.validations.forEach((validation, vBinding) => {
          if (vBinding !== binding && caresAboutDataChanges(/* @__PURE__ */ new Set([binding]), validation.weakBindings)) {
            validation.update(trigger, true, (validationObj) => {
              const response = this.validationRunner(
                validationObj,
                vBinding,
                context
              );
              return response ? { message: response.message } : void 0;
            });
          }
        });
      }
    }
    validationRunner(validationObj, binding, context = this.options) {
      if (!context) {
        throw new Error("No context provided to validation runner");
      }
      const handler = validationObj.handler ?? this.getValidator(validationObj.type);
      const weakBindings = /* @__PURE__ */ new Set();
      const model = {
        get(b, options) {
          weakBindings.add(isBinding(b) ? binding : context.parseBinding(b));
          return context.model.get(b, { ...options, includeInvalid: true });
        },
        set: context.model.set,
        delete: context.model.delete
      };
      const result = handler?.(
        {
          ...context,
          evaluate: (exp, options = { model }) => context.evaluate(exp, options),
          model,
          validation: validationObj,
          schemaType: this.schema.getType(binding)
        },
        context.model.get(binding, {
          includeInvalid: true,
          formatted: validationObj.dataTarget === "formatted"
        }),
        validationObj
      );
      this.weakBindingTracker = weakBindings;
      if (result) {
        let { message } = result;
        const { parameters } = result;
        if (validationObj.message) {
          message = resolveDataRefs(validationObj.message, {
            model,
            evaluate: context.evaluate
          });
          if (parameters) {
            message = replaceParams(message, parameters);
          }
        }
        return {
          message
        };
      }
    }
    updateValidationsForView(trigger) {
      const isNavigationTrigger = trigger === "navigation";
      const lastActiveBindings = this.activeBindings;
      const updateValidations = (dismissValidations) => {
        this.getBindings().forEach((binding) => {
          this.validations.get(binding)?.update(trigger, dismissValidations, (obj) => {
            if (!this.options) {
              return;
            }
            return this.validationRunner(obj, binding, this.options);
          });
        });
      };
      updateValidations(!isNavigationTrigger);
      if (isNavigationTrigger) {
        const { activeBindings } = this;
        if (isSubset(activeBindings, lastActiveBindings)) {
          updateValidations(true);
        }
      }
    }
    get activeBindings() {
      return new Set(
        Array.from(this.getBindings()).filter(
          (b) => this.validations.get(b)?.get() !== void 0
        )
      );
    }
    getValidator(type) {
      if (this.validatorRegistry) {
        return this.validatorRegistry.get(type);
      }
      const registry = new ValidatorRegistry();
      this.hooks.createValidatorRegistry.call(registry);
      this.validatorRegistry = registry;
      return registry.get(type);
    }
    getBindings() {
      return this.tracker?.getBindings() ?? /* @__PURE__ */ new Set();
    }
    trackBinding(binding) {
      this.tracker?.trackBinding(binding);
    }
    /** Executes all known validations for the tracked bindings using the given model */
    validateView(trigger = "navigation") {
      this.updateValidationsForView(trigger);
      const validations = /* @__PURE__ */ new Map();
      let canTransition = true;
      this.getBindings().forEach((b) => {
        const allValidations = this.getValidationForBinding(b)?.getAll();
        allValidations?.forEach((v) => {
          if (trigger === "navigation" && v.blocking) {
            this.options?.logger.debug(
              `Validation on binding: ${b.asString()} is preventing navigation. ${JSON.stringify(
                v
              )}`
            );
            canTransition = false;
          }
          if (!validations.has(b)) {
            validations.set(b, v);
          }
        });
      });
      return {
        canTransition,
        validations: validations.size ? validations : void 0
      };
    }
    /** Get the current tracked validation for the given binding */
    getValidationForBinding(binding) {
      return this.validations.get(binding);
    }
    forView(parser) {
      return {
        _getValidationForBinding: (binding) => {
          return this.getValidationForBinding(
            isBinding(binding) ? binding : parser(binding)
          );
        },
        getAll: () => {
          const bindings = this.getBindings();
          if (bindings.size === 0) {
            return void 0;
          }
          const validationMapping = /* @__PURE__ */ new Map();
          bindings.forEach((b) => {
            const validation = this.getValidationForBinding(b)?.get();
            if (validation) {
              validationMapping.set(b, validation);
            }
          });
          return validationMapping.size === 0 ? void 0 : validationMapping;
        },
        get() {
          throw new Error("Error Access be provided by the view plugin");
        },
        getValidationsForBinding() {
          throw new Error("Error rollup should be provided by the view plugin");
        },
        getChildren() {
          throw new Error("Error rollup should be provided by the view plugin");
        },
        getValidationsForSection() {
          throw new Error("Error rollup should be provided by the view plugin");
        },
        track: () => {
          throw new Error("Tracking should be provided by the view plugin");
        },
        register: () => {
          throw new Error(
            "Section functionality should be provided by the view plugin"
          );
        },
        type: (binding) => this.schema.getType(isBinding(binding) ? binding : parser(binding))
      };
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/view/controller.ts
  var import_queue_microtask = __toESM(require_queue_microtask());

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/node_modules/.aspect_rules_js/@player-ui+partial-match-registry@0.0.0/node_modules/@player-ui/partial-match-registry/dist/index.mjs
  var import_sorted_array = __toESM(require_sorted_array(), 1);
  function traverseObj(object, path = [], pairs = /* @__PURE__ */ new Map()) {
    for (const key of Object.keys(object)) {
      const val = object[key];
      const nestedPath = [...path, key];
      if (typeof val === "object") {
        traverseObj(val, nestedPath, pairs);
      } else {
        pairs.set(nestedPath, val);
      }
    }
    return pairs;
  }
  function createObjectMatcher(partialObj) {
    const pairs = traverseObj(partialObj);
    const matchFunction = (searchObj) => {
      for (const entry of Array.from(pairs)) {
        const [path, value] = entry;
        if (dlv_es_default(searchObj, path) !== value) {
          return false;
        }
      }
      return true;
    };
    matchFunction.count = pairs.size;
    return matchFunction;
  }
  function createBasicMatcher(seed) {
    const matcher = (match) => seed === match;
    matcher.count = 1;
    return matcher;
  }
  var createSortedArray = () => new import_sorted_array.default([], (c) => c.matcher.count);
  var Registry = class {
    constructor(initialSet) {
      this.store = createSortedArray();
      initialSet?.forEach(([match, value]) => {
        this.set(match, value);
      });
    }
    /** Add match -> value mapping to the registry */
    set(match, value) {
      const matcher = typeof match === "object" ? createObjectMatcher(match) : createBasicMatcher(match);
      this.store.insert({
        key: match,
        value,
        matcher
      });
    }
    /** Fetch the best match in the registry */
    get(query) {
      for (const entry of this.store.array) {
        if (entry.matcher(query)) {
          return entry.value;
        }
      }
    }
    /** Loop over all entries and run callback */
    forEach(callbackfn) {
      for (const entry of this.store.array) {
        callbackfn(entry);
      }
    }
    /** Reset the items in the registry */
    clear() {
      this.store = createSortedArray();
    }
    /** Check if the registry is empty*/
    isRegistryEmpty() {
      return this.store.array.length === 0;
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/view/controller.ts
  var mergeSets = (setA, setB) => {
    return /* @__PURE__ */ new Set([...setA?.values() ?? [], ...setB?.values() ?? []]);
  };
  var ViewController = class {
    constructor(initialViews, options) {
      this.hooks = {
        resolveView: new SyncWaterfallHook(),
        view: new SyncHook()
      };
      this.transformRegistry = new Registry();
      this.optimizeUpdates = true;
      this.viewOptions = options;
      this.viewMap = initialViews.reduce(
        (viewMap, view) => {
          viewMap[view.id] = view;
          return viewMap;
        },
        {}
      );
      options.flowController.hooks.flow.tap(
        "viewController",
        (flow) => {
          flow.hooks.transition.tap("viewController", (_oldState, newState) => {
            if (newState.value.state_type === "VIEW") {
              this.onView(newState.value);
            } else {
              this.currentView = void 0;
            }
          });
        }
      );
      const update = (updates, silent = false) => {
        if (this.currentView) {
          if (this.optimizeUpdates) {
            this.queueUpdate(updates, void 0, silent);
          } else {
            this.currentView.update();
          }
        }
      };
      options.model.hooks.onUpdate.tap(
        "viewController",
        (updates, updateOptions) => {
          update(
            new Set(updates.map((t2) => t2.binding)),
            updateOptions?.silent ?? false
          );
        }
      );
      options.model.hooks.onDelete.tap("viewController", (binding) => {
        const parentBinding = binding.parent();
        const property = binding.key();
        if (typeof property === "number" && parentBinding) {
          update(/* @__PURE__ */ new Set([parentBinding]));
        } else {
          update(/* @__PURE__ */ new Set([binding]));
        }
      });
      this.viewPlugins = this.createViewPlugins();
    }
    queueUpdate(bindings, nodes, silent = false) {
      if (!this.pendingUpdate) {
        this.pendingUpdate = {
          scheduled: false
        };
      }
      this.pendingUpdate = {
        ...this.pendingUpdate,
        changedBindings: mergeSets(this.pendingUpdate.changedBindings, bindings),
        changedNodes: mergeSets(this.pendingUpdate.changedNodes, nodes)
      };
      if (!this.pendingUpdate.scheduled && !silent) {
        this.pendingUpdate.scheduled = true;
        (0, import_queue_microtask.default)(() => {
          const { changedBindings, changedNodes } = this.pendingUpdate ?? {};
          this.pendingUpdate = void 0;
          this.currentView?.update(changedBindings, changedNodes);
        });
      }
    }
    getViewForRef(viewRef) {
      if (this.viewMap[viewRef]) {
        return this.viewMap[viewRef];
      }
      const matchingViewId = Object.keys(this.viewMap).find(
        (possibleViewIdMatch) => viewRef === resolveDataRefsInString(possibleViewIdMatch, {
          model: this.viewOptions.model,
          evaluate: this.viewOptions.evaluator.evaluate
        })
      );
      if (matchingViewId && this.viewMap[matchingViewId]) {
        return this.viewMap[matchingViewId];
      }
    }
    onView(state) {
      const viewId = state.ref;
      const source = this.hooks.resolveView.call(
        this.getViewForRef(viewId),
        viewId,
        state
      );
      if (!source) {
        throw new Error(`No view with id ${viewId}`);
      }
      const view = new ViewInstance(source, this.viewOptions);
      this.currentView = view;
      this.applyViewPlugins(view);
      this.hooks.view.call(view);
      view.update();
    }
    applyViewPlugins(view) {
      for (const plugin of this.viewPlugins) {
        plugin.apply(view);
      }
    }
    createViewPlugins() {
      const pluginOptions = toNodeResolveOptions(this.viewOptions);
      return [
        new AssetPlugin(),
        new SwitchPlugin(pluginOptions),
        new ApplicabilityPlugin(),
        new AssetTransformCorePlugin(this.transformRegistry),
        new StringResolverPlugin(),
        new TemplatePlugin(pluginOptions),
        new MultiNodePlugin()
      ];
    }
    /** Marks all AST nodes in `nodes` as changed, triggering the view to update and re-resolve these nodes. View updates are triggered asynchronously and many calls to this in a short time will batch into a single update.
     *
     * NOTE: In most cases view updates are handled automatically by changes to data or any other built-in functionality that would require a view update. Only call this function if absolutely necessary.
     */
    updateViewAST(nodes) {
      this.queueUpdate(void 0, nodes);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/data/utils.ts
  var ReadOnlyDataController = class {
    constructor(controller, logger) {
      this.controller = controller;
      this.logger = logger;
    }
    get(binding, options) {
      return this.controller.get(binding, options);
    }
    set(transaction, options) {
      this.logger?.error(
        "Error: Tried to set in a read only instance of the DataController"
      );
      return [];
    }
    delete(binding, options) {
      this.logger?.error(
        "Error: Tried to delete in a read only instance of the DataController"
      );
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/data/controller.ts
  var DataController = class {
    constructor(model, options) {
      this.hooks = {
        resolve: new SyncWaterfallHook(),
        resolveDataStages: new SyncWaterfallHook(),
        // On any set or get of an undefined value, redirect the value to be the default
        resolveDefaultValue: new SyncBailHook(),
        onDelete: new SyncHook(),
        onSet: new SyncHook(),
        onGet: new SyncHook(),
        onUpdate: new SyncHook(),
        format: new SyncWaterfallHook(),
        deformat: new SyncWaterfallHook(),
        serialize: new SyncWaterfallHook()
      };
      this.logger = options.logger;
      const middleware = options.middleware || [];
      this.baseMiddleware = [new LocalModel(model), ...middleware];
      this.trash = /* @__PURE__ */ new Set();
      this.pathResolver = options.pathResolver;
    }
    getModel() {
      if (!this.model) {
        const stages = this.hooks.resolveDataStages.call(this.baseMiddleware);
        const model = new PipelinedDataModel();
        model.setMiddleware(stages);
        this.model = model;
      }
      return this.model;
    }
    resolveDataValue(binding, value, deformat) {
      if (deformat) {
        return this.hooks.deformat.call(value, binding);
      }
      return value;
    }
    set(transaction, options) {
      let normalizedTransaction = [];
      if (Array.isArray(transaction)) {
        normalizedTransaction = transaction.map(([binding, value]) => {
          const parsed = this.pathResolver.parse(binding);
          return [
            parsed,
            this.resolveDataValue(parsed, value, Boolean(options?.formatted))
          ];
        });
      } else {
        normalizedTransaction = Object.keys(transaction).map(
          (binding) => {
            const parsed = this.pathResolver.parse(binding);
            const val = transaction[binding];
            return [
              parsed,
              this.resolveDataValue(parsed, val, Boolean(options?.formatted))
            ];
          }
        );
      }
      const setUpdates = normalizedTransaction.reduce(
        (updates, [binding, newVal]) => {
          const oldVal = this.get(binding, { includeInvalid: true });
          const update = {
            binding,
            newValue: newVal,
            oldValue: oldVal
          };
          if (dequal(oldVal, newVal)) {
            this.logger?.debug(
              `Skipping update for path: ${binding.asString()}. Value was unchanged: ${oldVal}`
            );
          } else {
            updates.push(update);
            this.logger?.debug(
              `Setting path: ${binding.asString()} from: ${oldVal} to: ${newVal}`
            );
          }
          return updates;
        },
        []
      );
      const result = this.getModel().set(normalizedTransaction, options);
      const setUpdateBindings = new Set(setUpdates.map((su) => su.binding));
      result.forEach((tr) => {
        if (!setUpdateBindings.has(tr.binding) && (tr.force === true || !dequal(tr.oldValue, tr.newValue))) {
          this.logger?.debug(
            `Path: ${tr.binding.asString()} was changed from: ${tr.oldValue} to: ${tr.newValue}`
          );
          setUpdates.push(tr);
        }
      });
      this.hooks.onSet.call(normalizedTransaction);
      if (setUpdates.length > 0) {
        this.hooks.onUpdate.call(setUpdates, options);
      }
      return result;
    }
    resolve(binding, readOnly) {
      return Array.isArray(binding) || typeof binding === "string" ? this.pathResolver.parse(binding, { readOnly }) : binding;
    }
    get(binding, options) {
      const resolved = binding instanceof BindingInstance ? binding : this.resolve(binding, true);
      let result = this.getModel().get(resolved, options);
      if (result === void 0 && !options?.ignoreDefaultValue) {
        const defaultVal = this.hooks.resolveDefaultValue.call(resolved);
        if (defaultVal !== result) {
          result = defaultVal;
        }
      }
      if (options?.formatted) {
        result = this.hooks.format.call(result, resolved);
      } else if (options?.formatted === false) {
        result = this.hooks.deformat.call(result, resolved);
      }
      this.hooks.onGet.call(binding, result);
      return result;
    }
    delete(binding, options) {
      if (typeof binding !== "string" && !Array.isArray(binding) && !(binding instanceof BindingInstance)) {
        throw new Error("Invalid arguments: delete expects a data path (string)");
      }
      const resolved = binding instanceof BindingInstance ? binding : this.resolve(binding, false);
      const parentBinding = resolved.parent();
      const property = resolved.key();
      const parentValue = this.get(parentBinding);
      const existedBeforeDelete = typeof parentValue === "object" && parentValue !== null && Object.prototype.hasOwnProperty.call(parentValue, property);
      this.getModel().delete(resolved, options);
      if (existedBeforeDelete && !this.get(resolved)) {
        this.trash.add(resolved);
      }
      this.hooks.onDelete.call(resolved);
    }
    serialize() {
      return this.hooks.serialize.call(this.get(""));
    }
    makeReadOnly() {
      return new ReadOnlyDataController(this, this.logger);
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/constants/utils.ts
  function flatten(obj, roots = [], sep = ".") {
    return Object.keys(obj).reduce(
      (memo, prop) => ({
        // create a new object
        // include previously returned object
        ...memo,
        ...Object.prototype.toString.call(obj[prop]) === "[object Object]" ? (
          // keep working if value is an object
          flatten(obj[prop], roots.concat([prop]))
        ) : (
          // include current prop and value and prefix prop with the roots
          { [roots.concat([prop]).join(sep)]: obj[prop] }
        )
      }),
      {}
    );
  }
  function objectToBatchSet(obj) {
    const flattenedObj = flatten(obj);
    const batchTxn = [];
    Object.keys(flattenedObj).forEach((key) => {
      batchTxn.push([new BindingInstance(key), flattenedObj[key]]);
    });
    return batchTxn;
  }

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/controllers/constants/index.ts
  var ConstantsController = class {
    constructor() {
      this.store = /* @__PURE__ */ new Map();
      this.tempStore = /* @__PURE__ */ new Map();
    }
    addConstants(data, namespace) {
      if (this.store.has(namespace)) {
        this.store.get(namespace)?.set(objectToBatchSet(data));
      } else {
        this.store.set(namespace, new LocalModel(data));
      }
    }
    getConstants(key, namespace, fallback) {
      const path = new BindingInstance(key);
      return this.tempStore.get(namespace)?.get(path) ?? this.store.get(namespace)?.get(path) ?? fallback;
    }
    setTemporaryValues(data, namespace) {
      if (this.tempStore.has(namespace)) {
        this.tempStore.get(namespace)?.set(objectToBatchSet(data));
      } else {
        this.tempStore.set(namespace, new LocalModel(data));
      }
    }
    clearTemporaryValues(namespace) {
      if (namespace) {
        this.tempStore.get(namespace)?.reset();
      } else {
        this.tempStore.forEach((value) => {
          value.reset();
        });
      }
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/plugins/flow-exp-plugin.ts
  var FlowExpPlugin = class {
    constructor() {
      this.name = "flow-exp-plugin";
    }
    apply(player) {
      let expressionEvaluator;
      const handleEval = (exp) => {
        if (exp) {
          if (typeof exp === "object" && "exp" in exp) {
            expressionEvaluator?.evaluate(exp.exp);
          } else {
            expressionEvaluator?.evaluate(exp);
          }
        }
      };
      player.hooks.expressionEvaluator.tap(this.name, (evaluator) => {
        expressionEvaluator = evaluator;
      });
      player.hooks.flowController.tap(this.name, (fc) => {
        fc.hooks.flow.tap(this.name, (flow) => {
          flow.hooks.onStart.tap(this.name, (exp) => handleEval(exp));
          flow.hooks.onEnd.tap(this.name, (exp) => handleEval(exp));
          flow.hooks.resolveTransitionNode.intercept({
            call: (nextState) => {
              if (nextState?.onStart) {
                handleEval(nextState.onStart);
              }
            }
          });
        });
      });
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/plugins/default-exp-plugin.ts
  var createFormatFunction = (schema) => {
    const handler = (ctx, value, formatName) => {
      return schema.getFormatterForType({ type: formatName })?.format(value) ?? value;
    };
    return handler;
  };
  var DefaultExpPlugin = class {
    constructor() {
      this.name = "flow-exp-plugin";
    }
    apply(player) {
      let formatFunction;
      player.hooks.schema.tap(this.name, (schemaController) => {
        formatFunction = createFormatFunction(schemaController);
      });
      player.hooks.expressionEvaluator.tap(this.name, (expEvaluator) => {
        if (formatFunction) {
          expEvaluator.addExpressionFunction("format", formatFunction);
        }
        expEvaluator.addExpressionFunction("log", (ctx, ...args) => {
          player.logger.info(...args);
        });
        expEvaluator.addExpressionFunction("debug", (ctx, ...args) => {
          player.logger.debug(...args);
        });
        expEvaluator.addExpressionFunction(
          "eval",
          (ctx, ...args) => {
            return ctx.evaluate(...args);
          }
        );
      });
    }
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/types.ts
  var NOT_STARTED_STATE = {
    ref: Symbol("not-started"),
    status: "not-started"
  };

  // ../../../../../../../../../../execroot/_main/bazel-out/k8-fastbuild/bin/core/player/src/player.ts
  var PLAYER_VERSION = true ? "0.15.0" : "unknown";
  var COMMIT = true ? "42891c40875b011e707e0ac48a14c995518f84fe" : "unknown";
  var _Player = class _Player {
    constructor(config) {
      this.logger = new TapableLogger();
      this.constantsController = new ConstantsController();
      this.state = NOT_STARTED_STATE;
      this.hooks = {
        flowController: new SyncHook(),
        viewController: new SyncHook(),
        view: new SyncHook(),
        expressionEvaluator: new SyncHook(),
        dataController: new SyncHook(),
        schema: new SyncHook(),
        validationController: new SyncHook(),
        bindingParser: new SyncHook(),
        state: new SyncHook(),
        onStart: new SyncHook(),
        onEnd: new SyncHook(),
        resolveFlowContent: new SyncWaterfallHook()
      };
      if (config?.logger) {
        this.logger.addHandler(config.logger);
      }
      this.config = config || {};
      this.config.plugins = [
        new DefaultExpPlugin(),
        ...this.config.plugins || [],
        new FlowExpPlugin()
      ];
      this.config.plugins?.forEach((plugin) => {
        plugin.apply(this);
      });
    }
    /**  Returns currently registered plugins */
    getPlugins() {
      return this.config.plugins ?? [];
    }
    /** Find instance of [Plugin] that has been registered to Player */
    findPlugin(symbol) {
      return this.config.plugins?.find((el) => el.symbol === symbol);
    }
    /** Retrieve an instance of [Plugin] and conditionally invoke [apply] if it exists */
    applyTo(symbol, apply) {
      const plugin = this.findPlugin(symbol);
      if (plugin) {
        apply(plugin);
      }
    }
    /** Register and apply [Plugin] if one with the same symbol is not already registered. */
    registerPlugin(plugin) {
      plugin.apply(this);
      this.config.plugins?.push(plugin);
    }
    /** Returns the current version of the running player */
    getVersion() {
      return _Player.info.version;
    }
    /** Returns the git commit used to build Player version */
    getCommit() {
      return _Player.info.commit;
    }
    /**
     * Fetch the current state of Player.
     * It will return either `not-started`, `in-progress`, `completed`
     * with some extra data in each
     */
    getState() {
      return this.state;
    }
    /**
     * A private means of setting the state of Player
     * Calls the hooks for subscribers to listen for this event
     */
    setState(state) {
      this.state = state;
      this.hooks.state.call(state);
    }
    /** Start Player with the given flow */
    setupFlow(userContent) {
      const userFlow = this.hooks.resolveFlowContent.call(userContent);
      const flowController = new FlowController(userFlow.navigation, {
        logger: this.logger
      });
      this.hooks.onStart.call(userFlow);
      this.hooks.flowController.call(flowController);
      let expressionEvaluator;
      let dataController;
      const pathResolver = new BindingParser({
        get: (binding) => {
          return dataController.get(binding);
        },
        set: (transaction) => {
          return dataController.set(transaction);
        },
        evaluate: (expression) => {
          return expressionEvaluator.evaluate(expression);
        }
      });
      this.hooks.bindingParser.call(pathResolver);
      const parseBinding = pathResolver.parse;
      const flowResultDeferred = (0, import_p_defer2.default)();
      const schema = new SchemaController(userFlow.schema);
      this.hooks.schema.call(schema);
      const validationController = new ValidationController(schema);
      this.hooks.validationController.call(validationController);
      dataController = new DataController(userFlow.data, {
        pathResolver,
        middleware: validationController.getDataMiddleware(),
        logger: this.logger
      });
      dataController.hooks.format.tap("player", (value, binding) => {
        const formatter = schema.getFormatter(binding);
        return formatter ? formatter.format(value) : value;
      });
      dataController.hooks.deformat.tap("player", (value, binding) => {
        const formatter = schema.getFormatter(binding);
        return formatter ? formatter.deformat(value) : value;
      });
      dataController.hooks.resolveDefaultValue.tap(
        "player",
        (binding) => schema.getApparentType(binding)?.default
      );
      let viewController;
      expressionEvaluator = new ExpressionEvaluator({
        model: dataController,
        logger: this.logger
      });
      this.hooks.expressionEvaluator.call(expressionEvaluator);
      expressionEvaluator.hooks.onError.tap("player", (e) => {
        flowResultDeferred.reject(e);
        return true;
      });
      function resolveStrings(val, formatted) {
        return resolveDataRefs(val, {
          model: dataController,
          evaluate: expressionEvaluator.evaluate,
          formatted
        });
      }
      flowController.hooks.flow.tap("player", (flow) => {
        flow.hooks.beforeTransition.tap("player", (state, transitionVal) => {
          const computedTransitionVal = state.transitions[transitionVal] ? transitionVal : "*";
          if (state.onEnd && state.transitions[computedTransitionVal]) {
            if (typeof state.onEnd === "object" && "exp" in state.onEnd) {
              expressionEvaluator?.evaluate(state.onEnd.exp);
            } else {
              expressionEvaluator?.evaluate(state.onEnd);
            }
          }
          if (!("transitions" in state) || !state.transitions[computedTransitionVal]) {
            return state;
          }
          return (0, import_timm9.setIn)(
            state,
            ["transitions", computedTransitionVal],
            resolveStrings(state.transitions[computedTransitionVal])
          );
        });
        flow.hooks.skipTransition.tap("validation", (currentState) => {
          if (currentState?.value.state_type === "VIEW") {
            const { canTransition, validations } = validationController.validateView("navigation");
            if (!canTransition && validations) {
              const bindings = new Set(validations.keys());
              viewController?.currentView?.update(bindings);
              return true;
            }
          }
          return void 0;
        });
        flow.hooks.resolveTransitionNode.tap("player", (state) => {
          let newState = state;
          if ("ref" in state) {
            newState = (0, import_timm9.setIn)(state, ["ref"], resolveStrings(state.ref));
          }
          if ("param" in state) {
            newState = (0, import_timm9.setIn)(
              state,
              ["param"],
              resolveStrings(state.param, false)
            );
          }
          return newState;
        });
        flow.hooks.transition.tap("player", (_oldState, newState) => {
          if (newState.value.state_type !== "VIEW") {
            validationController.reset();
          }
        });
        flow.hooks.afterTransition.tap("player-action-states", (flowInstance) => {
          const value = flowInstance.currentState?.value;
          if (value && value.state_type === "ASYNC_ACTION") {
            const { exp } = value;
            try {
              const result = expressionEvaluator.evaluateAsync(exp);
              if (isPromiseLike(result)) {
                if (value.await) {
                  (0, import_queue_microtask2.default)(() => {
                    result.then((r) => flowController?.transition(String(r))).catch(flowResultDeferred.reject);
                  });
                } else {
                  this.logger.warn(
                    "Unawaited promise used as return value in in non-async context, transitioning with '*' value"
                  );
                  flowController?.transition(String(result));
                }
              } else {
                this.logger.warn(
                  "Non async expression used in async action node"
                );
                flowController?.transition(String(result));
              }
            } catch (e) {
              flowResultDeferred.reject(e);
            }
          } else if (value && value.state_type === "ACTION") {
            const { exp } = value;
            const result = expressionEvaluator.evaluate(exp);
            if (isPromiseLike(result)) {
              this.logger.warn(
                "Async expression used as return value in in non-async context, transitioning with '*' value"
              );
            }
            flowController?.transition(String(result));
          }
          expressionEvaluator.reset();
        });
      });
      this.hooks.dataController.call(dataController);
      validationController.setOptions({
        parseBinding,
        model: dataController,
        logger: this.logger,
        evaluate: expressionEvaluator.evaluate,
        constants: this.constantsController
      });
      viewController = new ViewController(userFlow.views || [], {
        evaluator: expressionEvaluator,
        parseBinding,
        transition: flowController.transition,
        model: dataController,
        utils: {
          findPlugin: (pluginSymbol) => {
            return this.findPlugin(pluginSymbol);
          }
        },
        logger: this.logger,
        flowController,
        schema,
        format: (binding, value) => {
          const formatter = schema.getFormatter(binding);
          return formatter?.format ? formatter.format(value) : value;
        },
        formatValue: (ref, value) => {
          const formatter = schema.getFormatterForType(ref);
          return formatter?.format ? formatter.format(value) : value;
        },
        validation: {
          ...validationController.forView(parseBinding),
          type: (b) => schema.getType(parseBinding(b))
        },
        constants: this.constantsController
      });
      viewController.hooks.view.tap("player", (view) => {
        validationController.onView(view);
        this.hooks.view.call(view);
      });
      this.hooks.viewController.call(viewController);
      return {
        start: () => {
          flowController.start().then((endState) => {
            const flowResult = {
              endState: resolveStrings(endState, false),
              data: dataController.serialize()
            };
            return flowResult;
          }).then(flowResultDeferred.resolve).catch((e) => {
            this.logger.error(`Something went wrong: ${e.message}`);
            throw e;
          }).catch(flowResultDeferred.reject).finally(() => this.hooks.onEnd.call());
        },
        state: {
          status: "in-progress",
          flowResult: flowResultDeferred.promise,
          controllers: {
            data: dataController,
            view: viewController,
            flow: flowController,
            schema,
            expression: expressionEvaluator,
            binding: pathResolver,
            validation: validationController
          },
          fail: flowResultDeferred.reject,
          flow: userFlow,
          logger: this.logger
        }
      };
    }
    async start(payload) {
      const ref = Symbol(payload?.id ?? "payload");
      const maybeUpdateState = (newState) => {
        if (this.state.ref !== ref) {
          this.logger.warn(
            `Received update for a flow that's not the current one`
          );
          return newState;
        }
        this.setState(newState);
        return newState;
      };
      this.setState({
        status: "not-started",
        ref
      });
      try {
        const { state, start } = this.setupFlow(payload);
        this.setState({
          ref,
          ...state
        });
        start();
        const endProps = {
          ref,
          status: "completed",
          flow: state.flow,
          controllers: {
            data: state.controllers.data.makeReadOnly()
          }
        };
        return maybeUpdateState({
          ...await state.flowResult,
          ...endProps
        });
      } catch (error) {
        const errorState = {
          status: "error",
          ref,
          flow: payload,
          error
        };
        maybeUpdateState(errorState);
        throw error;
      }
    }
  };
  _Player.info = {
    version: PLAYER_VERSION,
    commit: COMMIT
  };
  var Player = _Player;
  return __toCommonJS(src_exports);
})();
/*! Bundled license information:

timm/lib/timm.js:
  (*!
   * Timm
   *
   * Immutability helpers with fast reads and acceptable writes.
   *
   * @copyright Guillermo Grau Panea 2016
   * @license MIT
   *)

queue-microtask/index.js:
  (*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> *)
*/
